import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import AddUserIcon from '@mui/icons-material/Add';
import AddUserImage from '@mui/icons-material/CloudUpload';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Dropzone from 'react-dropzone';
import Selector from '../select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PhoneInput from '../common/PhoneInput';
import moment from 'moment';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { toast } from 'react-toastify';
import MenuItem from '@mui/material/MenuItem';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import FormControlLabel from '@mui/material/FormControlLabel';
import spinner from '../assign-prescriptions/images/spinner.gif';
import FileIcon from './images/File-Icon.png';
import Switch from '@mui/material/Switch';
import PatientHistoryTab from '../patient-list/patientHistory.js';
import CONNECTION_TYPE from '../common/connection-type';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MaskedInput from 'react-text-mask';
import LOCATION_TYPE from '../enum/location_type';
import Grid from '@mui/material/Grid';
import PaymentMethods from './paymentMethods';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterDateFns';
import Box from '@mui/material/Box';
import PatientMadicationHistoryTab from '../patient-list/patient-madication-history.js';
import { withTranslation } from 'react-i18next';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr';
import ReportsAGGrid from "../reports/reportsGrid/reportsAGGrid";
import VerticalMenu from "./ActionCellRenderer";
import CloseIcon from '@mui/icons-material/Close';

// const uuidv4 = require("uuid/v4");
// import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@mui/icons-material/Remove';
// import MultipleSelect from "../common/MultipleSelect";

// let counter = 0;
// function createData(name, username, email, phone, protein, dob) {
//   counter += 1;
//   const emailaddress = name.split(" ")[0].toLowerCase() + "@pharmacy.com";
//   return {
//     id: counter,
//     name,
//     username,
//     email: emailaddress,
//     phone,
//     protein,
//     roles:
//       Math.random() > 0.33
//         ? Math.random() > 0.5
//           ? "Administrator"
//           : "Pharmacist"
//         : "Tech"
//   };
// }

const Accordion = withStyles({
  root: {
    borderBottom: 0,
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  },
  expanded: {
    margin: 'auto',
  },
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    borderBottom: '1px solid rgba(0,0,0,.125)',
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})((props) => <MuiAccordionSummary {...props} />);
MuiAccordionSummary.muiName = 'MuiAccordionSummary';

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing.unit * 2,
  },
}))(MuiAccordionDetails);

const courierType = [
  { id: LOCATION_TYPE.Home, label: 'Home' },
  { id: LOCATION_TYPE.Work, label: 'Work' },
  { id: LOCATION_TYPE.Other, label: 'Other' },
];
let account = [];
function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/]}
    //mask={[(/[01]/,'?',/[0-9]/,'|2',/[0-3]/),':',/[0-5]/,/[0-9]/]}
    // mask={
    // (([/([0-1])/]) ? ([/([0-1])/,/[\d]/,':',/([0]|[1]|[2]|[3]|[4]|[5])/,/[\d]/]) : ([/([2])/,/([0-3])/,':',/([0]|[1]|[2]|[3]|[4]|[5])/,/[\d]/]) )
    // }
    // showMask
    />
  );
}
TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

function TabContainer({ children, dir, classes }) {
  return (
    <Typography component='div' dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    //backgroundColor: theme.palette.secondary.main,
    backgroundColor: '#00a7e1',
    color: '#fff',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    add,
    confirmDelete,
    padd,
    pdelete,
    t,
    clearFilters
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 1,
      })}
    >
      <div className={classes.title}>
        {numSelected > 1 ? (
          <Typography color='inherit' variant='subheading'>
            {numSelected} {t('Patient.SelectedRowsCount')}
          </Typography>
        ) : null}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 1 ? (
          pdelete === true ? (
            <Tooltip
              key='multi-delete'
              title={t('Patient.DeletePatientTooltip')}
            >
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                sx={() => ({
                  '&:hover': { backgroundColor: '#6cca98', color: '#fff' },
                })}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ''
          )
        ) : padd === true ? (
          <div style={{ display: 'flex', width: '90px', justifyContent: 'space-between' }}>
            <Tooltip style={{ marginRight: '10px' }} key="clear-filters" title={t("Patient.ClearFiltersTooltip")}>
              <IconButton onClick={clearFilters} className={classes.add}>
                <CloseIcon style={{ color: "white" }} />
              </IconButton>
            </Tooltip>
            <Tooltip key='single-add' title={t('Patient.AddPatientTooltip')}>
              <IconButton
                aria-label='Add Patient'
                className={classes.add}
                onClick={add}
              >
                <AddUserIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          ''
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const styles = (theme) => ({
  Paper: {
    maxWidth: '1204px',
  },
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  '@media only screen and (min-width: 1024px) and (max-width:1440px) and (orientation:landscape)': {
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      // marginTop: theme.spacing.unit * 3,
      // height:'100%',
      // overflowY:'auto'
    },
  },
  table: {
    minWidth: 'auto',
  },
  advdropbox: {
    // width: "250px",
    height: '175px',
    //float: "right",
    // borderStyle: 'solid',
    // borderWidth: 'thin',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '5px',
    //right: "14px",
    position: 'relative',
    marginBottom: '15px',
  },
  flexItems: {
    display: 'flex',
    //justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  captionadvText: {
    lineHeight: '1',
    color: '#8a8a8a',
    fontSize: '13px',
    //marginTop: '-15px',
    // textAlign: 'center'
  },
  btnremove: {
    padding: '8px 2px',
    fontSize: '0.675rem',
  },
  mytablebody: {
    marginLeft: '0% !important',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  halfTextField: {
    marginRight: '20px',
    width: 400,
  },
  halfTextFieldLocation: {
    width: 450,
  },
  halfTextFieldAgents: {
    width: 160,
    marginRight: '100px',
    marginLeft: '-3rem',
  },
  styleBottom: {
    marginBottom: 20,
  },
  styleBottom1: {
    marginTop: 13,
  },
  dropbox: {
    width: '130px',
    height: '105px',
    float: 'right',
    // borderStyle: 'solid',
    // borderWidth: 'thin',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '25px',
    right: '2px',
    position: 'relative',
  },
  innerBox: {
    margin: '0 auto',
    display: 'block',
    height: '100%',
  },
  dropImage: {
    width: '80%',
    height: '100%',
  },
  customText: {
    margin: '0px',
  },
  previewBox: {
    height: '800px',
  },
  mainIframe: {
    width: '100%',
    height: '555px',
    border: '0px',
    outline: 'none',
  },
  dropPic: {
    width: '100%',
    height: '100%',
  },
  errorDiv: {
    paddingTop: '10px',
    color: 'red',
  },
  dob: {
    //paddingTop: "25px"
    marginTop: '-30px',
  },
  captionText: {
    lineHeight: '1',
    color: '#8a8a8a',
    fontSize: '13px',
    textAlign: 'center',
  },
  twoChildren: {
    display: 'flex',
  },
  leftChild: {},
  rightChild: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerConsent: {
    position: 'relative',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImageConsent: {
    top: 'calc(50% - 80.5px)',
    left: '25vw',
    right: '25vw',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
  iOSSwitchBase: {
    color: '#ec1515',
    '&$iOSChecked': {
      color: '#4cd964',
      '& + $iOSBar': {
        backgroundColor: '#fff',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(20px)',
    '& + $iOSBar': {
      opacity: 1,
      border: '1px solid #e3e3e3',
    },
  },
  iOSBar: {
    borderRadius: '10px',
    width: 70,
    height: 31,
    marginTop: -15,
    marginLeft: -32,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 50,
    height: 28,
    //background:'#efefef',
    border: '1px solid #e3e3e3',
    borderRadius: '10px !important',
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  resetbtn: {
    color: 'white',
    border: 0,
    height: '48px',
    padding: '0 30px',
    background: 'linear-gradient(135deg, #50A684 30%, #115E67 90%)',
    boxShadow: '0 3px 5px 2px rgba(135, 135, 135, .3)',
    borderRadius: '3px',
  },
  searchHalfTextField: {
    marginRight: '0px !important',
    width: 330,
    marginTop: '0px !important',
  },
  SeparateRow: {
    borderCollapse: 'separate !important',
    borderSpacing: '0 15px !important',
  },
  tableAddRowCell: {
    padding: '0px 0px 0px 0px !important',
  },
  wrapperBox: {
    boxShadow:
      '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
  },
  parentRemovePad: {
    padding: '5px !important',
  },
  removePad: {
    padding: '4px 4px !important',
    width: '10px',
  },
  removeBorders: {
    borderBottom: '1px solid rgb(255, 255, 255) !important',
  },
  AddIconButton: {
    backgroundColor: '#0a5d66',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0a5d66',
    },
  },
  oneThirdTextField: {
    marginRight: '20px',
  },
  locationWidth: {
    width: '450px',
  },
  addMaultiplePatientDeliveryAddress: {
    position: 'absolute',
    width: '95%',
    bottom: 'calc(100% - 100%)',
  },
  addMaultiplePatientDeliveryAddressPad: {
    position: 'absolute',
    width: '95%',
    bottom: 'calc(100% - 100%)',
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
  menuItem: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  divider: {
    marginTop: '10px',
    height: '5px',
    borderColor: 'rgba(0, 0, 0, 0.12)',
    borderStyle: 'solid',
    borderBottomWidth: '5px',
  },
});

let imgFile;
let LC;

const TransactionSortObj = {
  name: { tableName: '', sortColumn: 'name' },
  username: { tableName: '', sortColumn: 'username' },
  email: { tableName: 'contacts', sortColumn: 'email' },
  phone: { tableName: 'contacts', sortColumn: 'phone' },
  dob_str: { tableName: '', sortColumn: 'dob_str' },
}

let TransactionFilterObj = {
  searchObject: null,
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
}
class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      dob: new Date(),
      orderBy: 'created_on',
      selected: [],
      selectedTab: 0,
      isEditable: false,
      ada: false,
      Nsms: true,
      Nemail: true,
      Npush: false,
      page: 0,
      rowsPerPage: 25,
      submitted: false,
      isButtonDisabled: false,
      patientview: true,
      patientadd: true,
      patientdelete: true,
      patientedit: true,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone: null,
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        // room_no: '',
        // bed_no: '',
        // source_location: '',
        // destination_location: '',
        // selectedcouriertypelocation: '',
        // notes: '',
        // shelf: '',
      },
      box: {
        id: '',
        name: '',
      },
      loader: false,
      openIframe: false,
      dataUrl: '',
      IsActive: false,
      IsConsent: false,
      IsPayrollDeduct: false,
      customerLCpreview: null,
      confirmresetpw: false,
      OpenConfirmCode: false,
      shouldLookUpEnabled: false,
      searchPatient: '',
      searchPatientAction: 'MRN (Medical Record Number)',
      patientSelectedAction: 'MRN',
      innerloader: false,
      innerConsentloader: false,
      isBoxError: false,
      patient_id: '',
      member_id: '',
      Locations: [],
      locationtype: [],
      errorText: '',
      alternetAgents: [],
      disabledText: 'Disable',
      disableDialogOpen: false,
      patient_notes: '',
      boxDetails: [],
      location_notes: '',
      isPatientExist: false,
      parent_account_id: '',
      alllocations: [],
      location_id: null,
      box_id: '',
      courier_type: [],
      customer_pkid: '',
      isResuestConsent: false,
      PatientDeliveryAddress: [],
      expanded: 'panel0',
      docOneHash: null,
      docOneLabel: null,
      docOneDataURL: null,
      docTwoHash: null,
      docTwoLabel: null,
      docTwoDataURL: null,
      docThreeHash: null,
      docThreeLabel: null,
      docThreeDataURL: null,
      preferredLanguage: [
        { id: 'en', label: this.props.t('Global.Language.English') },
        { id: 'es', label: this.props.t('Global.Language.Spanish') },
        { id: 'fr', label: this.props.t('Global.Language.French') },
      ],
      preferLanguage: '',
      totalRecords: 0,
      pin: '',
      isPet: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeDocTwo = this.handleChangeDocTwo.bind(this);
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_BASEURL + 'roles', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((roleLookupValues) => this.setState({ roleLookupValues }));

    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return {
            value: account.id,
            label: account.name,
            preferredLanguage: account.preferred_language,
          };
        });
        this.setState({
          accountValues,
          parent_account_id: accountValues[0].value,
          loader: false,
        });
        account = accounts;
        this.getAccountConnectionType(
          this.state && this.state.parent_account_id
        );
        this.BindBoxesbyStoreId(accountValues.map((x) => x.value));
      });
    let permissions = JSON.parse(sessionStorage.getItem('permissions'));
    if (permissions && permissions.length > 0) {
      let permissionObj = {};
      permissions.map((item) => {
        return item.permission_entity_type === 'Manage Patients' &&
          item.name === 'View'
          ? (permissionObj.view = true)
          : item.permission_entity_type === 'Manage Patients' &&
            item.name === 'Add'
            ? (permissionObj.add = true)
            : item.permission_entity_type === 'Manage Patients' &&
              item.name === 'Modify'
              ? (permissionObj.modify = true)
              : item.permission_entity_type === 'Manage Patients' &&
                item.name === 'Delete'
                ? (permissionObj.delete = true)
                : null;
      });
      if (permissionObj.view) {
        this.setState({ patientview: true });
      } else {
        this.setState({ patientview: false });
      }
      if (permissionObj.add) {
        this.setState({ patientadd: true });
      } else {
        this.setState({ patientadd: false });
      }
      if (permissionObj.modify) {
        this.setState({ patientedit: true });
      } else {
        this.setState({ patientedit: false });
      }
      if (permissionObj.delete) {
        this.setState({ patientdelete: true });
      } else {
        this.setState({ patientdelete: false });
      }

      // if (permissions[20].is_allowed === false) {
      //   this.setState({ patientedit: false });
      // }
      // if (permissions[18].is_allowed === false) {
      //   this.setState({ patientview: false });
      // }
      // if (permissions[21].is_allowed === false) {
      //   this.setState({ patientdelete: false });
      // }
      // if (permissions[19].is_allowed === false) {
      //   this.setState({ patientadd: false });
      // }
    } else {
      this.setState({ patientview: false });
      this.setState({ patientadd: false });
      this.setState({ patientedit: false });
      this.setState({ patientdelete: false });
    }

    this.FindBoxes();
  }

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids,
      };
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(BoxesObj),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            this.setState({ loader: false });
            return null;
          }
        })
        .then((data) => {
          this.setState({
            alllocations: data,
            boxDetails: data,
            Locations: data,
            loader: false,
          });
        });
    }
  }

  getAllBoxes = (id) => {
    fetch(process.env.REACT_APP_BASEURL + 'getBoxesById/' + id, {
      method: 'get',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((data) => {
        this.setState({ loader: false });
        if (data && data.length > 0) {
          let tmp = data.map((val) => {
            return {
              id: val.id,
              value: val.name,
              location_notes: val.location_notes ? val.location_notes : '',
            };
          });
          if (this.state.Locations && this.state.Locations.length > 0) {
            let tm = this.state.Locations;
            // tm[0].location_notes = tmp[0].location_notes;
            this.setState({ boxDetails: tmp, Locations: tm, loader: false });
          }
        } else {
          this.setState({ boxDetails: [], loader: false });
        }
      });
  };

  handleSwitchChange = (name) => (event) => {
    this.setState({ IsActive: event.target.checked });
  };
  handleSwitchChangePayroll = (name) => (event) => {
    this.setState({ IsPayrollDeduct: event.target.checked });
  };
  handleSwitchChangeConsent = (name) => (event) => {
    this.setState({ IsConsent: event.target.checked });
  };

  FindBoxes() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'locationtypes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((locationtypes) => {
        if (locationtypes) {
          let t = [];
          for (let i = 0; i < locationtypes.length; i++) {
            if (
              locationtypes[i].name !== 'Home' &&
              locationtypes[i].name !== 'Work' &&
              locationtypes[i].name !== 'Mail Order'
            ) {
              let obj = {
                id: locationtypes[i].id,
                label: this.props.t(locationtypes[i].name_es),
              };
              t.push(obj);
            }
          }
          this.setState({ locationtype: t, loader: false });
        }
        this.setState({ loader: false });
      });
  }

  handleChangeActive = () => {
    this.setState({ IsActive: !this.state.IsActive });
  };

  addUser = (event) => {
    this.setState({ alternetAgents: [] }, () => {
      this.alternateAgentsMethod();
    });
    const getAccountByID = this.state.accountValues.find(
      (x) => x.value === this.state.parent_account_id
    );
    this.setState({
      showNewUserDialog: true,
      user: {},
      operation: 'Add',
      avatarPreview: null,
      first_name: '',
      last_name: '',
      email: '',
      phone: null,
      dob: new Date(),
      LCPreview: null,
      fileType: '',
      filename: '',
      LCfilename: '',
      doctwo: null,
      signature: null,
      patient_signature: null,
      patient_signature_time: null,
      signature_time: null,
      customerLCpreview: null,
      Locations: [],
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      alternetAgents: [],
      disabledText: 'Disable',
      disableDialogOpen: false,
      room_no: '',
      bed_no: '',
      source_location: '',
      destination_location: '',
      location_notes: '',
      conns0l_notex: '',
      selectedcouriertypelocation: '',
      notes: '',
      shelf: '',
      loader: false,
      IsPayrollDeduct: false,
      customer_pkid: '',
      patient_id: '',
      IsActive: false,
      IsConsent: false,
      PatientDeliveryAddress: [],
      isPet: false,
      pin: '',
      selectedTab: 0,
      preferLanguage: getAccountByID['preferredLanguage'],
    });
  };

  deleteUsers = (event) => {
    const result = fetch(process.env.REACT_APP_BASEURL + 'customers/' + this.state.selected.join(',').trim(','),
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      const newData = [];
      this.state.data.forEach((item) => {
        if (this.state.selected.indexOf(item.id) === -1) {
          newData.push(item);
        }
      });

      this.setState({
        loader: false,
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
      });
      const filterModel = this.gridApi.getFilterModel();
      if (Object.keys(filterModel).length > 0) {
        this.gridApi.setFilterModel(null);
        TransactionFilterObj.searchObject = null;
      }
      this.gridApi.refreshServerSide()
    });
  };

  handleLCDrop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      LCPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
      fileType: acceptedFiles[0].type,
      LCfilename: acceptedFiles[0].name,
      signature: null,
      signature_time: null,
    });
  };
  removeLC = () => {
    const parent = document.getElementById('LegalConsentdropzone');
    let LCSrc = ((parent.children && parent.children[0]).src = '');
    LC = new File([LCSrc], 'removeLC');
    this.setState({
      LCPreview: null,
      LCfilename: '',
      customerLCpreview: null,
      signature: null,
      signature_time: null,
    });
  };
  PreviewLC = () => {
    this.setState({
      openIframe: !this.state.openIframe,
      dataUrl:
        this.state.LCPreview === null ||
          this.state.LCPreview === 'null' ||
          this.state.LCPreview === 'undefined' ||
          this.state.LCPreview === undefined
          ? this.state.customerLCpreview
          : this.state.LCPreview,
    });
  };
  handleClosePreview = () => {
    this.setState({ openIframe: false, loader: false });
  };
  handleChangeDocTwo = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({
      doctwo: event.target.value,
      signature: null,
      signature_time: null,
    });
  };
  handleClose = (event) => {
    this.setState({
      showNewUserDialog: false,
      user: {},
      // avatarPreview: null,
      errorMessage: '',
      selectedTab: 0,
      loader: false,
    });
  };

  handleDateChange = (date) => {
    this.setState({ dob: date });
  };

  handleDrop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      avatarPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };

  removeImg = () => {
    const parent = document.getElementById('avatardropzone');
    let imgSrc = ((parent.children && parent.children[0]).src = '');

    imgFile = new File([imgSrc], 'filename');
  };

  handleChange = async (event) => {
    if (event.preventDefault) event.preventDefault();
    //const user = {};
    const { user } = this.state;
    user[event.target.name || event.target.id] = event.target.value;

    this.setState({ user });
    console.log('user', this.state.user);
  };

  handlePatientIdChange = (event) => {
    event.preventDefault();
    this.setState({ patient_id: event.target.value });
  };

  handleMemberNumber = (event) => {
    event.preventDefault();
    this.setState({ member_id: event.target.value });
  };

  handleChangeConfirmcode = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ confirmcode: event.target.value });
  };
  handleboxChange = (event) => {
    if (event.preventDefault) event.preventDefault();
    //const user = {};
    const { box } = this.state;
    box[event.target.name || event.target.id] = event.target.value;
    this.setState({ box, isBoxError: false });
  };

  handleTabChange = (event, value) => {
    this.setState({ selectedTab: value, expanded: 'panel0' });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  }

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };
  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteUsers();
    }
    this.setState({ deleteDialogOpen: false });
  };
  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    fetch(process.env.REACT_APP_BASEURL + 'customers/' + rowIdToDelete, {
      method: 'DELETE',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result && result.status === 400) {
          toast.error(result.message);
          this.setState({ loader: false });
          this.handleContextClose(event);
        } else {
          this.setState({ loader: false });
          this.handleContextClose(event);
          const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);
          this.setState({
            data: JSON.parse(JSON.stringify(newData)),
            selected: [],
            selectedRowId: null,
          });
          this.handleContextClose(event);
          toast.success(this.props.t('Toast.Success.PatientRemoved'));
          const filterModel = this.gridApi.getFilterModel();
          if (Object.keys(filterModel).length > 0) {
            this.gridApi.setFilterModel(null);
            TransactionFilterObj.searchObject = null;
          }
          this.gridApi.refreshServerSide();
        }
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ innerloader: true });
    this.setState({ isButtonDisabled: true });
    var input = document.querySelector('input[type="file"]');
    let elems7 = document
      .getElementById('LegalConsentdropzone')
      .getElementsByTagName('*');
    let input7 = elems7[1];
    var data = new FormData();
    data.append('file', input.files[0]);
    data.append('first_name', this.state.user.first_name || this.state.first_name);
    data.append('last_name', this.state.user.last_name || this.state.last_name);
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('email', this.state.user.email || this.state.email);
    data.append('phone', this.formatPhoneNumber(this.state.user.phone) || this.formatPhoneNumber(this.state.phone));
    data.append('dob', moment(this.state.dob).format('MM/DD/YYYY'));
    data.append('ada_compitible', this.state.ada);
    data.append('emailnotification', this.state.Nemail);
    data.append('smsnotification', this.state.Nsms);
    data.append('pushnotification', this.state.Npush);
    data.append('boxid', this.state.box_id);
    data.append('IsActive', this.state.IsActive);
    data.append('IsConsent', this.state.IsConsent);
    if (this.state.roles && this.state.roles.length > 0) {
      data.append('roles', this.state.roles.map((x) => x.id));
    }
    if (input7 && input7.files && input7.files.length > 0) {
      data.append('LC', input7.files[0]);
    }
    data.append('patient_id', this.state && this.state.patient_id.toString());
    data.append('member_id', this.state.member_id);
    data.append('courier_type', this.state.courier_type);
    data.append('Locations', JSON.stringify(this.state.Locations));
    data.append('address_line_1', this.state.user.address1 || this.state.address1);
    data.append('address_line_2', this.state.user.address2 || this.state.address2);
    data.append('city', this.state.user.city || this.state.city);
    data.append('state', this.state.user.state || this.state.state);
    data.append('zip', this.state.user.zip || this.state.zip);
    data.append('room_no', this.state.user.room_no || this.state.room_no);
    data.append('bed_no', this.state.user.bed_no || this.state.bed_no);
    data.append('source_location', this.state.user.source_location || this.state.source_location);
    data.append('destination_location', this.state.user.destination_location || this.state.destination_location);
    data.append('location_notes', this.state.user.location_notes || this.state.location_notes);
    data.append('patient_notes', this.state.user.patient_notes || this.state.patient_notes);
    data.append('notes', this.state.user.notes || this.state.notes);
    data.append('shelf', this.state.user.self || this.state.self);
    data.append('selectedcouriertypelocation', this.state.user.selectedcouriertypelocation || this.state.selectedcouriertypelocation);
    data.append('country', this.state.user.country || this.state.country);
    data.append('alternetAgents', JSON.stringify(this.state && this.state.alternetAgents));
    data.append('location_id', this.state.location_id);
    data.append('payroll_deduct', this.state.IsPayrollDeduct);
    data.append('deliveryAddresses', JSON.stringify(this.state && this.state.PatientDeliveryAddress));
    data.append('preferredlanguage', this.state.preferLanguage);
    data.append('pin', this.state.pin === undefined || this.state.pin === 'undefined' || this.state.pin === null || this.state.pin === 'null' || this.state.pin === '' ? 0 : this.state.pin);
    data.append('is_pet', this.state.isPet);
    const isPatientRecordNumberExist = this.handleValidatePatientId();
    if (!isPatientRecordNumberExist) {
      const result = fetch(process.env.REACT_APP_BASEURL + 'customers', {
        method: 'POST',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: data,
      });
      result
        .then((result) => {
          result.json().then((res) => {
            this.setState({ innerloader: false, loader: false });
            if (res.error) {
              this.setState({ isButtonDisabled: false, submitted: false });
              this.setState({ errorMessage: res.error.message });
            } else {
              this.state.data.unshift(res.customer);
              const newData = JSON.parse(JSON.stringify(this.state.data));
              this.setState({
                isButtonDisabled: false,
                submitted: true,
                showNewUserDialog: false,
                user: {},
                avatarPreview: null,
                errorMessage: '',
                data: newData,
                LCPreview: null,
                Locations: [],
                alternetAgents: [],
                PatientDeliveryAddress: [],
              });
              toast.success(this.props.t('Toast.Success.PatientInformation'));
              const filterModel = this.gridApi.getFilterModel();
              if (Object.keys(filterModel).length > 0) {
                this.gridApi.setFilterModel(null);
                TransactionFilterObj.searchObject = null;
              }
              this.gridApi.refreshServerSide();
            }
          });
        })
        .catch((error) => {
          this.setState({ innerloader: false, loader: false });
          this.setState({ errorMessage: error.message });
        });
    } else {
      toast.error(this.props.t('Toast.Error.PatientNumberAlreadyExist'));
    }
    this.gridApi.forEachNode(node => node.setSelected(false))
  };

  handleUpdate = (event) => {
    event.preventDefault();
    this.setState({ innerloader: true });
    this.setState({ isButtonDisabled: true });
    var input = document.querySelector('input[type="file"]');
    let elems7 = document
      .getElementById('LegalConsentdropzone')
      .getElementsByTagName('*');
    let input7 = elems7[1];
    var data = new FormData();
    if (
      input.files !== null &&
      input.files !== undefined &&
      input.files.length > 0
    ) {
      if (input.files[0] != null || '') {
        data.append('file', input.files[0] || this.state.user.picture_url);
      } else {
        if (imgFile !== null && imgFile !== undefined && imgFile.length > 0) {
          data.append('file', imgFile[0]);
        }
      }
    }
    if (input7 && input7.files && input7.files.length > 0) {
      data.append('LC', input7.files[0]);
    } else if (LC && LC.name === 'removeLC') {
      data.append('LC', LC[0]);
    } else if (this.state.LCPreview !== null) {
      data.append('LC', this.state.LCPreview);
    } else {
      data.append('LC', this.state.customerLCpreview);
    }
    data.append('signature', this.state.signature);
    data.append('signature_time', this.state.signature_time);
    data.append('id', this.state.user.id);
    data.append('first_name', this.state.user.first_name);
    data.append('last_name', this.state.user.last_name);
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('email', this.state.user.email || this.state.email);
    data.append(
      'phone',
      this.formatPhoneNumber(this.state.user.phone) ||
      this.formatPhoneNumber(this.state.phone)
    );
    data.append('dob', moment(this.state.dob).format('MM/DD/YYYY'));
    data.append('ada_compitible', this.state.ada);
    data.append('emailnotification', this.state.Nemail);
    data.append('smsnotification', this.state.Nsms);
    data.append('pushnotification', this.state.Npush);
    data.append('boxid', this.state.box_id);
    data.append('IsActive', this.state.IsActive);
    data.append('IsConsent', this.state.IsConsent);
    data.append('consent_id', this.state.consent_id);
    data.append('Locations', JSON.stringify(this.state.Locations));
    data.append(
      'address_line_1',
      this.state.user.address1 || this.state.address1
    );
    data.append(
      'address_line_2',
      this.state.user.address2 || this.state.address2
    );
    data.append('city', this.state.user.city || this.state.city);
    data.append('room_no', this.state.user.room_no || this.state.room_no);
    data.append('bed_no', this.state.user.bed_no || this.state.bed_no);
    data.append(
      'source_location',
      this.state.user.source_location || this.state.source_location
    );
    data.append(
      'destination_location',
      this.state.user.destination_location || this.state.destination_location
    );
    data.append(
      'location_notes',
      this.state.user.location_notes || this.state.location_notes
    );
    data.append(
      'patient_notes',
      this.state.user.patient_notes || this.state.patient_notes
    );
    data.append(
      'notes',
      this.state.user.patient_notes || this.state.patient_notes
    );
    data.append('shelf', this.state.user.self || this.state.self);
    data.append(
      'selectedcouriertypelocation',
      this.state.user.selectedcouriertypelocation ||
      this.state.selectedcouriertypelocation
    );
    data.append('state', this.state.user.state || this.state.state);
    data.append('zip', this.state.user.zip || this.state.zip);
    data.append('country', this.state.user.country || this.state.country);
    data.append(
      'alternetAgents',
      JSON.stringify(this.state && this.state.alternetAgents)
    );
    data.append('patient_id', this.state.patient_id.toString());
    data.append('member_id', this.state.member_id);
    data.append('location_id', this.state.location_id);
    data.append('payroll_deduct', this.state.IsPayrollDeduct);
    data.append(
      'deliveryAddresses',
      JSON.stringify(this.state && this.state.PatientDeliveryAddress)
    );
    data.append('preferredlanguage', this.state.preferLanguage);
    data.append(
      'pin',
      this.state.pin === undefined ||
        this.state.pin === 'undefined' ||
        this.state.pin === null ||
        this.state.pin === 'null' ||
        this.state.pin === ''
        ? 0
        : this.state.pin
    );
    data.append('is_pet', this.state.isPet);
    const result = fetch(process.env.REACT_APP_BASEURL + 'customers', {
      method: 'PUT',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ innerloader: false, loader: false });
          if (res.error) {
            this.setState({ isButtonDisabled: false, submitted: false });
            this.setState({ errorMessage: res.error.message });
          } else {
            const newData = this.state.data.filter(
              (x) => x.id !== this.state.user.id
            );
            newData.unshift(res.customer);
            newData.map((n) => {
              n.email =
                n.contacts && n.contacts.length > 0 ? n.contacts[0].email : '';
              n.phone =
                n.contacts && n.contacts.length > 0 ? n.contacts[0].phone : '';
              return n;
            });
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              user: {},
              avatarPreview: null,
              errorMessage: '',
              LCPreview: null,
              data: JSON.parse(JSON.stringify(newData)),
              loader: false,
            });
            toast.success(this.props.t('Toast.Success.PatientUpdated'));
            const filterModel = this.gridApi.getFilterModel();
            if (Object.keys(filterModel).length > 0) {
              this.gridApi.setFilterModel(null);
              TransactionFilterObj.searchObject = null;
            }
            this.gridApi.refreshServerSide();
          }
        });
      })
      .catch((error) => {
        this.setState({ innerloader: false, loader: false });
        this.setState({ errorMessage: error.message });
      });
    this.gridApi.forEachNode(node => node.setSelected(false))
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleChangeEmail = () => {
    this.setState({ Nemail: !this.state.Nemail });
  };

  handleChangeSms = () => {
    this.setState({ Nsms: !this.state.Nsms });
  };

  handleChangePush = () => {
    this.setState({ Npush: !this.state.Npush });
  };

  handleChangeAda = () => {
    this.setState({ ada: !this.state.ada });
  };

  filterCustomerType = (typeName) => {
    let type = '';
    if (
      typeName !== null &&
      typeName !== 'null' &&
      typeName !== undefined &&
      typeName !== 'undefined' &&
      typeName !== ''
    ) {
      if (typeName.toString().toLowerCase() === 'portal') {
        type = this.props.t('Global.Patients.Type.Connect');
      } else if (typeName.toString().toLowerCase() === 'enrolled') {
        type = this.props.t('Global.Patients.Type.Kiosk');
      } else if (typeName.toString().toLowerCase() === 'pms') {
        type = this.props.t('Global.Patients.Type.PMS');
      }
    } else {
      type = '';
    }

    return type;
  };
  getAccountConnectionType = (accountID) => {
    fetch(process.env.REACT_APP_BASEURL + 'getAccountConnectionTypeByaccountID/' + accountID,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((accountConnectionsId) => {
        if (accountConnectionsId.length > 0) {
          this.setState({
            accountConnectionID: accountConnectionsId[0].account_connection_id,
            loader: false,
          });
        } else {
          this.setState({ accountConnectionID: null, loader: false });
        }
        if (
          accountConnectionsId[0].account_connection_id === CONNECTION_TYPE.EPIC
        ) {
          this.setState({ shouldLookUpEnabled: true });
        }
      });
  };
  resetPassword = () => {
    //this.handleClose();
    this.setState({ confirmresetpw: true });
  };
  confirmresetpw = () => {
    let userobj = {
      accountID: this.state.parent_account_id,
      name: this.state.user.first_name + this.state.user.last_name,
      firstname: this.state.user.first_name,
      lastname: this.state.user.last_name,
      email: this.state.email,
      phone: this.state.phone,
      box: this.state.box_id,
    };
    fetch(process.env.REACT_APP_BASEURL + 'SendCodeForResetPassword', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(userobj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((data) => { });
    this.setState({
      confirmresetpw: false,
      OpenConfirmCode: true,
      loader: false,
    });
  };
  confirmresetpwClose = () => {
    this.setState({ confirmresetpw: false });
  };
  confirmcodeClose = () => {
    this.setState({ OpenConfirmCode: false });
  };
  confirmcode = () => {
    alert(this.state.email);
  };

  handleLookupPatientSearch = (event) => {
    this.setState({ searchPatient: event.target.value });
  };

  handleRadioChange = (event) => {
    let labelValue;
    if (event.target.value === 'MRN') {
      labelValue = 'MRN (Medical Record Number)';
    } else if (event.target.value === 'MYCHARTLOGIN') {
      labelValue = 'My Chart Username';
    }
    this.setState({
      patientSelectedAction: event.target.value,
      searchPatientAction: labelValue,
    });
  };

  handleLookupPatient = () => {
    this.setState({ innerloader: true });
    const {
      parent_account_id,
      patientSelectedAction,
      searchPatient,
    } = this.state;
    let _lookupObj = {};
    _lookupObj.patientIdentifier = `${patientSelectedAction}|${searchPatient}`;
    _lookupObj.patientParentAccountId = parent_account_id;
    fetch(process.env.REACT_APP_BASEURL + 'epic/patient-lookup', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(_lookupObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((patientResponse) => {
        if (
          patientResponse.res.status === 404 ||
          patientResponse.res.status === 500
        ) {
          toast.error(patientResponse.res.message);
          this.setState({
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            dob: null,
            searchPatient: '',
            patient_id: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            room_no: '',
            bed_no: '',
            source_location: '',
            destination_location: '',
            location_notes: '',
            patient_notes: '',
            selectedcouriertypelocation: '',
            notes: '',
            shelf: '',
            innerloader: false,
            pin: '',
          });
          return;
        }
        let patientObj = patientResponse.res.body;
        this.setState({
          first_name: patientObj.firstName,
          last_name: patientObj.lastName,
          email: patientObj.email,
          phone:
            this.formatPhoneNumber(patientObj.phone.mobile) ||
            this.formatPhoneNumber(patientObj.phone.work) ||
            this.formatPhoneNumber(patientObj.phone.home),
          dob: patientObj.dob,
          searchPatient: '',
          patient_id: patientObj.MRN,
          address1: patientObj.address.line,
          address2: '',
          city: patientObj.address.city,
          state: patientObj.address.state,
          zip: patientObj.address.postalCode,
          country: patientObj.address.country,
          room_no: patientObj.address.room_no,
          bed_no: patientObj.address.bed_no,
          selectedcouriertypelocation:
            patientObj.address.selectedcouriertypelocation,
          source_location: patientObj.address.source_location,
          destination_location: patientObj.address.destination_location,
          location_notes: patientObj.address.location_notes,
          patient_notes: patientObj.address.patient_notes,
          notes: patientObj.address.notes,
          shelf: patientObj.address.shelf,
          innerloader: false,
          loader: false,
          pin: patientObj.pin,
        });
      });
  };

  handleValidate = (event) => {
    const {
      operation,
      user,
      email,
      patient_id,
      dob,
      parent_account_id,
    } = this.state;
    const { t } = this.props;
    if (operation === 'Add') {
      // if(box.boxid === '' || box.boxid === null || box.boxid === undefined || box.boxid === 'undefined') {
      //   this.setState({ isBoxError: true, selectedTab: 1 });
      // } else { this.state.IsActive === true
      if (this.state.Locations.length === 0) {
        this.setState({
          errorMessage: t('Patient.Validation.SelectAtLeastOneLocation'),
          selectedTab: 1,
        });
      } else {
        this.setState({ innerloader: true });
        let _patientObject = {
          email: user.email || email,
          patient_id: patient_id,
          dob: moment(dob).format('MM/DD/YYYY'),
          parent_account_id: parent_account_id,
        };
        fetch(process.env.REACT_APP_BASEURL + 'validate-patient', {
          method: 'POST',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
          body: JSON.stringify(_patientObject),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              this.setState({ loader: false });
              return null;
            }
          })
          .then((patientExist) => {
            if (patientExist.res === true || patientExist.res === 'true') {
              toast.error(this.props.t('Toast.Error.PatientInformationAlreadyExist'));
              this.setState({ innerloader: false, loader: false });
              return;
            } else {
              this.handleSubmit(event);
            }
          });
      }
    } else {
      if (this.state.IsActive === true && this.state.Locations.length === 0) {
        this.setState({
          errorMessage: t('Patient.Validation.SelectAtLeastOneLocation'),
          selectedTab: 1,
          loader: false,
        });
      } else {
        this.handleUpdate(event);
      }
    }
    // this.state.operation === 'Add' ? this.handleSubmit : this.handleUpdate
  };

  formatPhoneNumber = (phoneNumberString) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
  };

  onChangeLocationType = (idx) => (evt) => {
    this.setState({ location_notes: '', innerloader: true, loader: false });
    this.setState({
      loader: true,
      location_id: evt.target.value,
      box_id: evt.target.value,
    });
    let location_type_id = '';
    let id = '';
    let location_notes = '';
    if (this.state.alllocations && this.state.alllocations.length > 0) {
      location_type_id = this.state.alllocations.filter(
        (val) => val.id === evt.target.value
      );
      id = location_type_id[0].id;
      location_notes = location_type_id[0].location_notes;
      location_type_id = location_type_id[0].location_type_id;
    }
    this.setState({ locationtype_id: location_type_id });
    fetch(`${process.env.REACT_APP_BASEURL}boxes/${id}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        let theBox = boxes[0];
        this.setState({ locationType: evt.target.value });
        let courier_type = [];
        if (theBox.courier_type && theBox.courier_type.length > 0) {
          for (let i = 0; i < theBox.courier_type.length; i++) {
            courier_type.push({
              courier_type: theBox.courier_type[i].courier_type,
            });
          }
        }
        const locationtype = this.state.Locations.map((item, sidx) => {
          if (idx !== sidx) return item;
          return {
            id: id,
            locationtype_id: location_type_id,
            box_id: theBox.id,
            name: item.name || theBox.name,
            addressline1:
              item.addressline1 ||
              (theBox && theBox.address && theBox.address.address_line_1),
            addressline2:
              item.addressline2 ||
              (theBox && theBox.address && theBox.address.address_line_2),
            city:
              item.city || (theBox && theBox.address && theBox.address.city),
            state:
              item.state || (theBox && theBox.address && theBox.address.state),
            zip: item.zip || (theBox && theBox.address && theBox.address.zip),
            country:
              item.country ||
              (theBox && theBox.address && theBox.address.country),
            is_default_address: item.is_default_address || false,
            room_no: item.room_no || '',
            bed_no: item.bed_no || '',
            source_location: item.source_location || '',
            // destination_location: item.destination_location,
            location_notes: location_notes || (theBox && theBox.location_notes),
            patient_notes: item.patient_notes,
            selectedcouriertypelocation: item.selectedcouriertypelocation,
            notes: item.notes,
            shelf: item.shelf,
            courier_type: courier_type,
          };
        });
        this.setState({
          Locations: locationtype,
          innerloader: false,
          loader: false,
          courier_type:
            theBox.courier_type && theBox.courier_type.length > 0
              ? theBox.courier_type.map((val) => {
                return val.courier_type;
              })
              : [],
        });
      });
  };

  onChangeLocationType1 = (idx) => (evt) => {
    this.setState({ location_notes: '' });
    // this.getAllBoxes(evt.target.value);
    this.setState({ loader: true });
    this.setState({ locationType: evt.target.value });
    const locationtype = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: item.id,
        locationtype_id: evt.target.value,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        // destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
        courier_type: item.courier_type,
      };
    });
    this.setState({ Locations: locationtype });
  };

  onChangePatientNotes = (idx) => (evt) => {
    this.setState({ locationType: evt.target.value });
    const locationtype = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: evt.target.value,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        // destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationtype });
  };
  onChangeCourierLocationType = (idx) => (evt) => {
    const locationname = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        // destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: evt.target.value,
        notes: item.notes,
        shelf: item.shelf,
        courier_type: item.courier_type,
      };
    });
    this.setState({ Locations: locationname });
  };

  onChangeBoxType = (idx) => (evt) => {
    this.setState({ box_id: evt.target.value });
    if (this.state.boxDetails && this.state.boxDetails.length > 0) {
      let location = this.state.boxDetails.filter(
        (val) => val.id === evt.target.value
      );
      this.setState(
        { location_notes: location[0].location_notes, alllocations: location },
        () => {
          const boxtype = this.state.Locations.map((item, sidx) => {
            if (idx !== sidx) return item;
            return {
              id: sidx,
              locationtype_id: item.locationtype_id,
              box_id: evt.target.value,
              name: item.name,
              addressline_1: item.addressline1,
              addressline_2: item.addressline2,
              city: item.city,
              state: item.state,
              zip: item.zip,
              country: item.country,
              is_default_address: item.is_default_address,
              room_no: item.room_no,
              bed_no: item.bed_no,
              source_location: item.source_location,
              // destination_location: item.destination_location,
              location_notes: this.state.location_notes,
              patient_notes: item.patient_notes,
              selectedcouriertypelocation: item.selectedcouriertypelocation,
              notes: item.notes,
              shelf: item.shelf,
            };
          });
          this.setState({
            Locations: boxtype,
            box: evt.target.value,
            isBoxError: false,
          });
        }
      );
    }
  };

  onChangeLocationname = (idx) => (evt) => {
    const locationname = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        // destination_location: evt.target.value,
        location_notes: evt.target.value,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationname });
  };
  onChangeLocationnotes = (event) => {
    this.setState({ patient_notes: event.target.value }, () => {
      let obj = this.state.Locations;
      obj[0].patient_notes = this.state.patient_notes;
      this.setState({ Locations: obj });
    });
  };
  onChangeShelf = (idx) => (evt) => {
    const locationname = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        // destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: evt.target.value,
      };
    });
    this.setState({ Locations: locationname });
  };
  onChangeSourceLocation = (idx) => (evt) => {
    const locationname = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: evt.target.value,
        // destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationname });
  };
  onChangeDestinationLocation = (idx) => (evt) => {
    const locationname = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        // destination_location: evt.target.value,
        location_notes: evt.target.value,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationname });
  };
  onChangeBedNo = (idx) => (evt) => {
    const locationname = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: evt.target.value,
        source_location: item.source_location,
        destination_location: item.destination_location,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
      };
    });
    this.setState({ Locations: locationname });
  };
  onChangeRoomNo = (idx) => (evt) => {
    const locationname = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: evt.target.value,
        bed_no: item.bed_no,
        source_location: item.source_location,
        destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
        courier_type: item.courier_type,
      };
    });
    this.setState({ Locations: locationname });
  };
  onChangeAddreeline1 = (idx) => (evt) => {
    if (evt.target.value.match('^[a-zA-Z0-9 ]*$')) {
      // this.setState({erroraddress:false , errorTextaddress: '' })
      document.getElementById(`Location_AddressLine1_${idx}`).style.display =
        'none';
    } else {
      // this.setState({ erroraddress:true , errorTextaddress: 'Please Use Only Alphabets/Digits' })
      document.getElementById(`Location_AddressLine1_${idx}`).style.display =
        'block';
    }
    const locationaddressline1 = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: evt.target.value,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationaddressline1 });
  };
  onChangeAddreeline2 = (idx) => (evt) => {
    const locationaddressline2 = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: evt.target.value,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationaddressline2 });
  };
  onChangeLocationCity = (idx) => (evt) => {
    if (evt.target.value.match('^[a-zA-Z ]*$')) {
      // this.setState({errorcity:false , errorTextcity: '' })
      document.getElementById(`LocationCity_${idx}`).style.display = 'none';
    } else {
      // this.setState({ errorcity:true , errorTextcity: 'Please Use Only Alphabets' })
      document.getElementById(`LocationCity_${idx}`).style.display = 'block';
    }
    const locationcity = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: evt.target.value,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationcity });
  };
  onChangeLocationState = (idx) => (evt) => {
    if (evt.target.value.match('^[a-zA-Z ]*$')) {
      // this.setState({errorstate:false , errorTextstate: '' })
      document.getElementById(`LocationState_${idx}`).style.display = 'none';
    } else {
      // this.setState({ errorstate:true , errorTextstate: 'Please Use Only Alphabets' })
      document.getElementById(`LocationState_${idx}`).style.display = 'block';
    }
    const locationstate = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: evt.target.value,
        zip: item.zip,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationstate });
  };
  onChangeLocationZip = (idx) => (evt) => {
    if (evt.target.value.match('^[0-9 ]*$')) {
      // this.setState({errorzip:false , errorTextzip: '' })
      document.getElementById(`LocationZip_${idx}`).style.display = 'none';
    } else {
      // this.setState({ errorzip:true , errorTextzip: 'Please Use Only Digits' })
      document.getElementById(`LocationZip_${idx}`).style.display = 'block';
    }
    const locationzip = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: evt.target.value,
        country: item.country,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationzip });
  };
  onChangeLocationCountry = (idx) => (evt) => {
    if (evt.target.value.match('^[a-zA-Z ]*$')) {
      // this.setState({errorcountry:false , errorTextcountry: '' })
      document.getElementById(`LocationCountry_${idx}`).style.display = 'none';
    } else {
      // this.setState({ errorcountry:true , errorTextcountry: 'Please Use Only Alphabets' })
      document.getElementById(`LocationCountry_${idx}`).style.display = 'block';
    }
    const locationcountry = this.state.Locations.map((item, sidx) => {
      if (idx !== sidx) return item;
      return {
        id: sidx,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: evt.target.value,
        is_default_address: item.is_default_address,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.location_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
      };
    });
    this.setState({ Locations: locationcountry });
  };
  onChangeDefaultLocation = (event, locationId, idx) => {
    event.preventDefault();
    const locationdefault = this.state.Locations.map((item, sidx) => {
      return {
        id: item.id,
        locationtype_id: item.locationtype_id,
        box_id: item.box_id,
        name: item.name,
        addressline1: item.addressline1,
        addressline2: item.addressline2,
        city: item.city,
        state: item.state,
        zip: item.zip,
        country: item.country,
        is_default_address:
          locationId === item.id && sidx === idx ? true : false,
        room_no: item.room_no,
        bed_no: item.bed_no,
        source_location: item.source_location,
        destination_location: item.destination_location,
        location_notes: item.location_notes,
        patient_notes: item.patient_notes,
        selectedcouriertypelocation: item.selectedcouriertypelocation,
        notes: item.notes,
        shelf: item.shelf,
        courier_type: item.courier_type,
      };
    });
    this.setState({ Locations: locationdefault });
  };

  onChangeAgentFirstName = (idx) => (evt) => {
    const agent_firstname =
      this.state &&
      this.state.alternetAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: evt.target.value,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternetAgents: agent_firstname });
  };

  onChangeAgentLastName = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternetAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: evt.target.value,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternetAgents: agentdata });
  };

  onChangeAgentEmail = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternetAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: evt.target.value,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternetAgents: agentdata });
  };

  onChangeAgentsmsphone = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternetAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: evt.target.value,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternetAgents: agentdata });
  };

  onChangeAgentActive = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternetAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: evt.target.checked,
        };
      });
    this.setState({ alternetAgents: agentdata });
  };

  onlyoneCheckbox = (idx) => {
    const checkboxupdate = this.state.Locations.map((item) => {
      if (item.id === idx) {
        item.is_default_address = true;
      } else {
        item.is_default_address = false;
      }
      return item;
    });
    this.setState({ Locations: checkboxupdate });
    this.forceUpdate();
  };

  removePatientDeliveryAddressRow = (i) => {
    this.setState({
      PatientDeliveryAddress: this.state.PatientDeliveryAddress.filter(
        (s, sidx) => i !== sidx
      ),
    });
  };

  onChangePatientAddressLineOne = (index) => (event) => {
    console.log(event);
    const patientAddressLineOneObj = this.state.PatientDeliveryAddress.map(
      (item, pidx) => {
        if (index !== pidx) return item;
        return {
          id: pidx,
          address_line_1: event.target.value,
          address_line_2: item.address_line_2,
          city: item.city,
          state: item.state,
          zip: item.zip,
          country: item.country,
          is_primary_address: item.is_primary_address,
        };
      }
    );
    this.setState({ PatientDeliveryAddress: patientAddressLineOneObj });
  };

  onChangePatientAddressLineTwo = (index) => (event) => {
    const patientAddressLineTwoObj = this.state.PatientDeliveryAddress.map(
      (item, pidx) => {
        if (index !== pidx) return item;
        return {
          id: pidx,
          address_line_1: item.address_line_1,
          address_line_2: event.target.value,
          city: item.city,
          state: item.state,
          zip: item.zip,
          country: item.country,
          is_primary_address: item.is_primary_address,
        };
      }
    );
    this.setState({ PatientDeliveryAddress: patientAddressLineTwoObj });
  };

  onChangePatientCity = (index) => (event) => {
    const patientCityObj = this.state.PatientDeliveryAddress.map(
      (item, pidx) => {
        if (index !== pidx) return item;
        return {
          id: pidx,
          address_line_1: item.address_line_1,
          address_line_2: item.address_line_2,
          city: event.target.value,
          state: item.state,
          zip: item.zip,
          country: item.country,
          is_primary_address: item.is_primary_address,
        };
      }
    );
    this.setState({ PatientDeliveryAddress: patientCityObj });
  };

  onChangePatientState = (index) => (event) => {
    const patientStateObj = this.state.PatientDeliveryAddress.map(
      (item, pidx) => {
        if (index !== pidx) return item;
        return {
          id: pidx,
          address_line_1: item.address_line_1,
          address_line_2: item.address_line_2,
          city: item.city,
          state: event.target.value,
          zip: item.zip,
          country: item.country,
          is_primary_address: item.is_primary_address,
        };
      }
    );
    this.setState({ PatientDeliveryAddress: patientStateObj });
  };

  onChangePatientZipCode = (index) => (event) => {
    const patientZipObj = this.state.PatientDeliveryAddress.map(
      (item, pidx) => {
        if (index !== pidx) return item;
        return {
          id: pidx,
          address_line_1: item.address_line_1,
          address_line_2: item.address_line_2,
          city: item.city,
          state: item.state,
          zip: event.target.value,
          country: item.country,
          is_primary_address: item.is_primary_address,
        };
      }
    );
    this.setState({ PatientDeliveryAddress: patientZipObj });
  };

  onChangePatientCountry = (index) => (event) => {
    const patientCountryObj = this.state.PatientDeliveryAddress.map(
      (item, pidx) => {
        if (index !== pidx) return item;
        return {
          id: pidx,
          address_line_1: item.address_line_1,
          address_line_2: item.address_line_2,
          city: item.city,
          state: item.state,
          zip: item.zip,
          country: event.target.value,
          is_primary_address: item.is_primary_address,
        };
      }
    );
    this.setState({ PatientDeliveryAddress: patientCountryObj });
  };

  onClickCheckDefaultDeliveryAddress = (
    event,
    patientDeliveryAddressId,
    idx
  ) => {
    event.preventDefault();
    const patientDefaultDeliveryAddressObj = this.state.PatientDeliveryAddress.map(
      (item, pidx) => {
        return {
          id: item.id,
          address_line_1: item.address_line_1,
          address_line_2: item.address_line_2,
          city: item.city,
          state: item.state,
          zip: item.zip,
          country: item.country,
          is_primary_address:
            patientDeliveryAddressId === item.id && pidx === idx ? true : false,
        };
      }
    );
    this.setState({ PatientDeliveryAddress: patientDefaultDeliveryAddressObj });
  };

  addPatientDeliveryAddressRow = () => {
    this.setState({
      PatientDeliveryAddress: this.state.PatientDeliveryAddress.concat([
        {
          address_line_1: '',
          address_line_2: '',
          city: '',
          state: '',
          zip: '',
          country: '',
          is_primary_address: false,
        },
      ]),
    });
  };

  createPatientDeliveryAddressRow = () => {
    const { classes, t } = this.props;
    const { PatientDeliveryAddress, operation } = this.state;
    const readOnly = operation === 'View';

    let row =
      PatientDeliveryAddress &&
      PatientDeliveryAddress.length > 0 &&
      PatientDeliveryAddress.map((val, index) => (
        <TableRow key={index} className={classes.wrapperBox}>
          <TableCell
            colSpan={3}
            className={`${classes.parentRemovePad} ${classes.removeBorders}`}
          >
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    rowSpan={5}
                    className={`${classes.removePad}  ${classes.removeBorders}`}
                  >
                    <div className={classes.iconGroup}>
                      <Button
                        onClick={() =>
                          this.removePatientDeliveryAddressRow(index)
                        }
                        color='primary'
                        disabled={Boolean(readOnly)}
                      >
                        {t('Patient.Details.AddPatientRemoveButton')}
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
                <React.Fragment>
                  <TableRow>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          margin='dense'
                          className={classes.halfTextFieldLocation}
                          value={val.address_line_1}
                          label={t('Patient.Details.AddPatientAddressLine1')}
                          onChange={this.onChangePatientAddressLineOne(index)}
                          fullWidth
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                            readOnly: Boolean(readOnly),
                            maxLength: 100,
                          }}
                          variant='standard'
                        />
                        <div
                          id={`PatientAddressLine1_${index}`}
                          style={{
                            color: 'red',
                            display: 'none',
                            marginBottom: '-20px',
                          }}
                        >
                          <label>Please Use Only Alphabets/Digits</label>
                        </div>
                      </FormControl>
                    </TableCell>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          className={classes.halfTextFieldLocation}
                          margin='dense'
                          value={val.address_line_2}
                          label={t('Patient.Details.AddPatientAddressLine2')}
                          onChange={this.onChangePatientAddressLineTwo(index)}
                          fullWidth
                          InputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                            readOnly: Boolean(readOnly),
                            maxLength: 100,
                          }}
                          variant='standard'
                        />
                        <div
                          id={`Patient_AddressLine2_${index}`}
                          style={{
                            color: 'red',
                            display: 'none',
                            marginBottom: '-20px',
                          }}
                        >
                          <label>Please Use Only Alphabets/Digits</label>
                        </div>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          margin='dense'
                          className={classes.halfTextFieldLocation}
                          value={val.city}
                          label={t('Patient.Details.AddPatientCity')}
                          onChange={this.onChangePatientCity(index)}
                          fullWidth
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 100,
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant='standard'
                        />
                        <div
                          id={`PatientCity_${index}`}
                          style={{
                            color: 'red',
                            display: 'none',
                            marginBottom: '-20px',
                          }}
                        >
                          <label>Please Use Only Alphabets</label>
                        </div>
                      </FormControl>
                    </TableCell>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          className={classes.halfTextFieldLocation}
                          margin='dense'
                          value={val.state}
                          label={t('Patient.Details.AddPatientState')}
                          onChange={this.onChangePatientState(index)}
                          fullWidth
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 100,
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant='standard'
                        />
                        <div
                          id={`PatientState_${index}`}
                          style={{
                            color: 'red',
                            display: 'none',
                            marginBottom: '-20px',
                          }}
                        >
                          <label>Please Use Only Alphabets</label>
                        </div>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          margin='dense'
                          className={classes.halfTextFieldLocation}
                          value={val.zip}
                          label={t('Patient.Details.AddPatientZip')}
                          onChange={this.onChangePatientZipCode(index)}
                          fullWidth
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant='standard'
                        />
                        <div
                          id={`PatientZip_${index}`}
                          style={{
                            color: 'red',
                            display: 'none',
                            marginBottom: '-20px',
                          }}
                        >
                          <label>Please Use Only Digits</label>
                        </div>
                      </FormControl>
                    </TableCell>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          className={classes.halfTextFieldLocation}
                          margin='dense'
                          value={val.country}
                          label={t('Patient.Details.AddPatientCountry')}
                          onChange={this.onChangePatientCountry(index)}
                          fullWidth
                          inputProps={{
                            readOnly: Boolean(readOnly),
                            maxLength: 100,
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant='standard'
                        />
                        <div
                          id={`PatientCountry_${index}`}
                          style={{
                            color: 'red',
                            display: 'none',
                            marginBottom: '-20px',
                          }}
                        >
                          <label>Please Use Only Alphabets</label>
                        </div>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
                <TableRow>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={val.is_primary_address}
                          id={val.is_primary_address}
                          onClick={(e) =>
                            this.onClickCheckDefaultDeliveryAddress(
                              e,
                              val.id,
                              index
                            )
                          }
                          value='default'
                          color='primary'
                          readOnly={Boolean(readOnly)}
                          disabled={Boolean(readOnly)}
                        />
                      }
                      label={
                        <span style={{ color: '#000' }}>
                          {t('Patient.Details.AddPatientDefaultCheckboxButton')}
                        </span>
                      }
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableCell>
        </TableRow>
      ));
    return row;
  };

  createRow = () => {
    const { classes, t } = this.props;
    const { alllocations, Locations, operation, locationtype } = this.state;
    const readOnly = operation === 'View';
    const _allLocationsOfPatient = alllocations.map((al) => {
      return { value: al.id, label: al.name };
    });
    let row =
      Locations &&
      Locations &&
      Locations.map((val, idx) => (
        <TableRow key={idx} className={classes.wrapperBox}>
          <TableCell
            colSpan={3}
            className={`${classes.parentRemovePad} ${classes.removeBorders}`}
          >
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    rowSpan={5}
                    className={`${classes.removePad}  ${classes.removeBorders}`}
                  >
                    <div className={classes.iconGroup}>
                      <Button
                        onClick={() => this.removeRow(idx)}
                        color='primary'
                      >
                        {t('Patient.Preference.AddLocationRemoveButton')}
                      </Button>
                    </div>
                  </TableCell>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    <FormControl className={classes.boxType}>
                      <InputLabel htmlFor='box_type' sx={{ ml: '-3%' }}>
                        {t('Patient.Preference.Location')}
                      </InputLabel>
                      <Select
                        className={classes.halfTextFieldLocation}
                        value={val.box_id || ''}
                        onChange={this.onChangeLocationType(idx)}
                        readOnly={readOnly}
                        variant='standard'
                      >
                        {_allLocationsOfPatient.map((location, index) => (
                          <MenuItem key={index} value={location.value} selected>
                            {location.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    {val.locationtype_id === LOCATION_TYPE.Kiosk ||
                      val.locationtype_id === LOCATION_TYPE.Curbside ||
                      val.locationtype_id === LOCATION_TYPE.Courier ||
                      val.locationtype_id === LOCATION_TYPE.Other ||
                      val.locationtype_id === LOCATION_TYPE.Bedside ||
                      val.locationtype_id === LOCATION_TYPE.Counter ||
                      val.locationtype_id === LOCATION_TYPE.Mail_Order ? (
                      <FormControl className={classes.boxType}>
                        <InputLabel htmlFor='age-simple' sx={{ ml: '-3%' }}>
                          {t('Patient.Preference.LocationType')}
                        </InputLabel>
                        <Select
                          className={classes.halfTextFieldLocation}
                          value={val.locationtype_id || ''}
                          onChange={this.onChangeLocationType1(idx)}
                          variant='standard'
                        >
                          {locationtype.map((locationtype, index) => (
                            <MenuItem
                              key={index}
                              value={locationtype.id}
                              selected
                            >
                              {locationtype.label}
                            </MenuItem>
                          ))}
                        </Select>
                        {this.state && this.state.isBoxError === true ? (
                          <div style={{ color: 'red' }}>
                            <label>Please select box</label>
                          </div>
                        ) : (
                          <span></span>
                        )}
                      </FormControl>
                    ) : val.locationtype_id === LOCATION_TYPE.Home ||
                      val.locationtype_id === LOCATION_TYPE.Work ||
                      val.locationtype_id === LOCATION_TYPE.Bedside ||
                      val.locationtype_id === LOCATION_TYPE.Counter ||
                      val.locationtype_id === LOCATION_TYPE.Other ? (
                      <FormControl className={classes.boxType}>
                        <label style={{ color: '#858585' }}>
                          {t('Patient.Preference.LocationNotes')}
                        </label>
                        <textarea
                          rows='1'
                          cols='500'
                          name='LocationName'
                          value={val.name}
                          style={{
                            resize: 'none',
                            borderRadius: '0px',
                            paddingLeft: '0px',
                            width: '86%',
                            borderLeft: 'none',
                            borderTop: 'none',
                            borderRight: 'none',
                            fontFamily: 'Arial',
                            fontSize: '1rem',
                            paddingBottom: '10px',
                          }}
                        />
                      </FormControl>
                    ) : val.locationtype_id === LOCATION_TYPE.Courier ? (
                      <FormControl className={classes.boxType}>
                        <InputLabel htmlFor='age-simple'>
                          {t('Patient.Preference.CourierLocationType')}
                        </InputLabel>
                        <Select
                          className={classes.halfTextFieldLocation}
                          value={val.selectedcouriertypelocation || ''}
                          onChange={this.onChangeCourierLocationType(idx)}
                          variant='standard'
                        >
                          {courierType.map((locationtype, index) => (
                            <MenuItem
                              key={index}
                              value={locationtype.id}
                              selected
                            >
                              {locationtype.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : val.locationtype_id === LOCATION_TYPE.Curbside ? (
                      <FormControl className={classes.boxType}>
                        <label style={{ color: '#858585' }}>
                          {t('Patient.Preference.LocationNotes')}
                        </label>
                        <textarea
                          rows='1'
                          cols='500'
                          name='LocationName'
                          value={val.location_notes}
                          style={{
                            resize: 'none',
                            borderRadius: '0px',
                            paddingLeft: '0px',
                            width: '86%',
                            borderLeft: 'none',
                            borderTop: 'none',
                            borderRight: 'none',
                            fontFamily: 'Arial',
                            fontSize: '1rem',
                            paddingBottom: '10px',
                          }}
                        />
                      </FormControl>
                    ) : (
                      ''
                    )}
                  </TableCell>
                </TableRow>

                {val.locationtype_id === LOCATION_TYPE.Courier ||
                  val.locationtype_id === LOCATION_TYPE.Other ||
                  val.locationtype_id === LOCATION_TYPE.Mail_Order ? (
                  <TableRow>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <label style={{ color: '#858585' }}>
                          {t('Patient.Preference.LocationNotes')}
                        </label>
                        <textarea
                          rows='1'
                          cols='500'
                          name='LocationName'
                          value={val.location_notes}
                          style={{
                            resize: 'none',
                            borderRadius: '0px',
                            paddingLeft: '0px',
                            width: '86%',
                            borderLeft: 'none',
                            borderTop: 'none',
                            borderRight: 'none',
                            fontFamily: 'Arial',
                            fontSize: '1rem',
                            paddingBottom: '10px',
                          }}
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ) : val.locationtype_id === LOCATION_TYPE.Kiosk ||
                  val.locationtype_id === LOCATION_TYPE.Curbside ? (
                  <TableRow>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <label style={{ color: '#858585' }}>
                          {t('Patient.Preference.LocationNotes')}
                        </label>
                        <textarea
                          rows='1'
                          cols='500'
                          name='LocationName'
                          value={val.location_notes}
                          style={{
                            resize: 'none',
                            borderRadius: '0px',
                            paddingLeft: '0px',
                            width: '86%',
                            borderLeft: 'none',
                            borderTop: 'none',
                            borderRight: 'none',
                            fontFamily: 'Arial',
                            fontSize: '1rem',
                            paddingBottom: '10px',
                          }}
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ) : val.locationtype_id === LOCATION_TYPE.Counter ? (
                  <TableRow>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <label style={{ color: '#858585' }}>
                          {t('Patient.Preference.LocationNotes')}
                        </label>
                        <textarea
                          rows='1'
                          cols='500'
                          name='LocationName'
                          value={val.location_notes}
                          style={{
                            resize: 'none',
                            borderRadius: '0px',
                            paddingLeft: '0px',
                            width: '86%',
                            borderLeft: 'none',
                            borderTop: 'none',
                            borderRight: 'none',
                            fontFamily: 'Arial',
                            fontSize: '1rem',
                            paddingBottom: '10px',
                          }}
                        />
                      </FormControl>
                    </TableCell>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          margin='dense'
                          className={classes.halfTextFieldLocation}
                          value={val.shelf}
                          label={t('Patient.Preference.Shelf')}
                          placeholder=''
                          onChange={this.onChangeShelf(idx)}
                          fullWidth
                          InputProps={{
                            autocomplete: 'new-password',
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant='standard'
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ) : val.locationtype_id === LOCATION_TYPE.Bedside ? (
                  <TableRow>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <label style={{ color: '#858585' }}>
                          {t('Patient.Preference.LocationNotes')}
                        </label>
                        <textarea
                          rows='1'
                          cols='500'
                          name='LocationName'
                          value={val.location_notes}
                          style={{
                            resize: 'none',
                            borderRadius: '0px',
                            paddingLeft: '0px',
                            width: '86%',
                            borderLeft: 'none',
                            borderTop: 'none',
                            borderRight: 'none',
                            fontFamily: 'Arial',
                            fontSize: '1rem',
                            paddingBottom: '10px',
                          }}
                        />
                      </FormControl>
                    </TableCell>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          margin='dense'
                          className={classes.halfTextFieldLocation}
                          value={val.room_no}
                          label={t('Patient.Preference.RoomNumber')}
                          placeholder=''
                          onChange={this.onChangeRoomNo(idx)}
                          fullWidth
                          InputProps={{
                            autocomplete: 'new-password',
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant='standard'
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ) : (
                  ''
                )}
                {val.locationtype_id === LOCATION_TYPE.Bedside ? (
                  <TableRow>
                    <TableCell
                      className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                    >
                      <FormControl className={classes.boxType}>
                        <TextField
                          margin='dense'
                          className={classes.halfTextFieldLocation}
                          value={val.bed_no}
                          label={t('Patient.Preference.BedNumber')}
                          placeholder=''
                          onChange={this.onChangeBedNo(idx)}
                          fullWidth
                          InputProps={{
                            autocomplete: 'new-password',
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant='standard'
                        />
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ) : (
                  ''
                )}
                {val.locationtype_id === LOCATION_TYPE.Kiosk ||
                  val.locationtype_id === LOCATION_TYPE.Curbside ||
                  val.locationtype_id === LOCATION_TYPE.Courier ||
                  val.locationtype_id === LOCATION_TYPE.Bedside ||
                  val.locationtype_id === LOCATION_TYPE.Counter ? (
                  ''
                ) : (
                  <React.Fragment>
                    <TableRow>
                      <TableCell
                        className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                      >
                        <FormControl className={classes.boxType}>
                          <TextField
                            margin='dense'
                            className={classes.halfTextFieldLocation}
                            value={val.addressline1}
                            label={t(
                              'Patient.Preference.AddLocationAddressLine1'
                            )}
                            placeholder=''
                            onChange={this.onChangeAddreeline1(idx)}
                            fullWidth
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 100,
                              autocomplete: 'new-password',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            variant='standard'
                          />
                          <div
                            id={`Location_AddressLine1_${idx}`}
                            style={{
                              color: 'red',
                              display: 'none',
                              marginBottom: '-20px',
                            }}
                          >
                            <label>Please Use Only Alphabets/Digits</label>
                          </div>
                        </FormControl>
                      </TableCell>
                      <TableCell
                        className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                      >
                        <FormControl className={classes.boxType}>
                          <TextField
                            className={classes.halfTextFieldLocation}
                            margin='dense'
                            value={val.addressline2}
                            label={t(
                              'Patient.Preference.AddLocationAddressLine2'
                            )}
                            placeholder=''
                            onChange={this.onChangeAddreeline2(idx)}
                            fullWidth
                            InputProps={{
                              autocomplete: 'new-password',
                              form: {
                                autocomplete: 'off',
                              },
                              readOnly: Boolean(readOnly),
                              maxLength: 100,
                            }}
                            variant='standard'
                          />
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                      >
                        <FormControl className={classes.boxType}>
                          <TextField
                            margin='dense'
                            className={classes.halfTextFieldLocation}
                            value={val.city}
                            label={t('Patient.Preference.AddLocationCity')}
                            placeholder=''
                            onChange={this.onChangeLocationCity(idx)}
                            fullWidth
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'new-password',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            variant='standard'
                          />
                          <div
                            id={`LocationCity_${idx}`}
                            style={{
                              color: 'red',
                              display: 'none',
                              marginBottom: '-20px',
                            }}
                          >
                            <label>Please Use Only Alphabets</label>
                          </div>
                        </FormControl>
                      </TableCell>
                      <TableCell
                        className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                      >
                        <FormControl className={classes.boxType}>
                          <TextField
                            className={classes.halfTextFieldLocation}
                            margin='dense'
                            value={val.state}
                            label={t('Patient.Preference.AddLocationState')}
                            placeholder=''
                            onChange={this.onChangeLocationState(idx)}
                            fullWidth
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'new-password',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            variant='standard'
                          />
                          <div
                            id={`LocationState_${idx}`}
                            style={{
                              color: 'red',
                              display: 'none',
                              marginBottom: '-20px',
                            }}
                          >
                            <label>Please Use Only Alphabets</label>
                          </div>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                      >
                        <FormControl className={classes.boxType}>
                          <TextField
                            margin='dense'
                            className={classes.halfTextFieldLocation}
                            value={val.zip}
                            label={t('Patient.Preference.AddLocationZip')}
                            placeholder=''
                            onChange={this.onChangeLocationZip(idx)}
                            fullWidth
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              autocomplete: 'new-password',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            variant='standard'
                          />
                          <div
                            id={`LocationZip_${idx}`}
                            style={{
                              color: 'red',
                              display: 'none',
                              marginBottom: '-20px',
                            }}
                          >
                            <label>Please Use Only Digits</label>
                          </div>
                        </FormControl>
                      </TableCell>
                      <TableCell
                        className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                      >
                        <FormControl className={classes.boxType}>
                          <TextField
                            className={classes.halfTextFieldLocation}
                            margin='dense'
                            value={val.country}
                            label={t('Patient.Preference.AddLocationCountry')}
                            placeholder=''
                            onChange={this.onChangeLocationCountry(idx)}
                            fullWidth
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'new-password',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            variant='standard'
                          />
                          <div
                            id={`LocationCountry_${idx}`}
                            style={{
                              color: 'red',
                              display: 'none',
                              marginBottom: '-20px',
                            }}
                          >
                            <label>Please Use Only Alphabets</label>
                          </div>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                )}
                <TableRow>
                  <TableCell
                    className={`${classes.parentRemovePad} ${classes.removeBorders}`}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={val.is_default_address}
                          id={val.is_default_address}
                          onClick={(e) =>
                            this.onChangeDefaultLocation(e, val.id, idx)
                          }
                          value='default'
                          color='primary'
                        />
                      }
                      label={
                        <span style={{ color: '#000' }}>
                          {t(
                            'Patient.Preference.AddLocationDefaultCheckboxButton'
                          )}
                        </span>
                      }
                    />
                  </TableCell>
                  <TableCell>
                    {val.courier_type && val.courier_type.length > 0
                      ? val.courier_type.map((va) => {
                        return (
                          <div>
                            <FormControlLabel
                              control={
                                <Checkbox color='primary' checked={true} />
                              }
                              label={
                                <span style={{ color: '#000' }}>
                                  {va.courier_type}
                                </span>
                              }
                            />
                          </div>
                        );
                      })
                      : ''}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableCell>
        </TableRow>
      ));
    return row;
  };

  createRowAlterAgent = () => {
    const { classes, t } = this.props;
    const readOnly = this.state && this.state.operation === 'View';
    let alternetAgents = this.state && this.state.alternetAgents;
    let row =
      alternetAgents &&
      alternetAgents.map((val, idx) => (
        <div className={classes.styleBottom}>
          <React.Fragment>
            <div>
              <Grid container>
                <Grid item xs={2}>
                  <Button
                    style={{ marginLeft: '4%', marginTop: '10%' }}
                    className={classes.styleBottom1}
                    onClick={() => this.removeAlternetAgentRow(idx)}
                    color='primary'
                  >
                    {t('Patient.Preference.AlternateContactRemoveButton')}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className={classes.styleBottom1}
                  style={{ marginLeft: '-4rem' }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={val.isdefault}
                        onChange={this.onChangeAgentActive(idx)}
                        value='default'
                        color='primary'
                      />
                    }
                    label={
                      <span
                        style={{
                          color: '#000',
                          fontSize: '0.875rem',
                          fontWeight: '400',
                          lineHeight: '1.46429em',
                        }}
                      >
                        {t('Patient.Preference.AlternateContactActiveCheckbox')}
                      </span>
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_firstname}
                    id='agent_firstname'
                    label={t('Patient.Preference.AlternateContactFirstName')}
                    placeholder=''
                    onChange={this.onChangeAgentFirstName(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: Boolean(readOnly),
                      maxLength: 50,
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_lastname}
                    id='Last_Name'
                    label={t('Patient.Preference.AlternateContactLastName')}
                    placeholder=''
                    onChange={this.onChangeAgentLastName(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: Boolean(readOnly),
                      maxLength: 50,
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_email}
                    id='Email'
                    label={t('Patient.Preference.AlternateContactEmail')}
                    placeholder=''
                    onChange={this.onChangeAgentEmail(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: Boolean(readOnly),
                      maxLength: 50,
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2} style={{ marginLeft: '-3rem' }}>
                  <PhoneInput
                    labelStyle={{ left: '-13px', top: '-17px' }}
                    className={classes.halfTextFieldAgents}
                    id='smsphone'
                    name='phone'
                    onBlur={this.onChangeAgentsmsphone(idx)}
                    defaultValue={val.agent_sms}
                    readOnly={readOnly}
                  />
                </Grid>
              </Grid>
            </div>
          </React.Fragment>
        </div>
      ));
    return row;
  };

  addRow = () => {
    this.setState({
      Locations: this.state.Locations.concat([
        {
          locationtype_id: '',
          box_id: null,
          name: '',
          address_line_1: '',
          address_line_2: '',
          city: '',
          state: '',
          zip: '',
          country: '',
          courier_type: [],
          room_no: '',
          bed_no: '',
          source_location: '',
          destination_location: '',
          location_notes: '',
          patient_notes: '',
          selectedcouriertypelocation: '',
          notes: '',
          shelf: '',
          is_default_address: false,
        },
      ]),
    });
  };

  addAlterAgentRow = () => {
    this.setState({
      alternetAgents:
        this.state &&
        this.state.alternetAgents &&
        this.state.alternetAgents.concat([
          {
            agent_firstname: '',
            agent_lastname: '',
            agent_email: '',
            agent_sms: '',
            isdefault: false,
          },
        ]),
    });
  };

  removeRow = (i) => {
    const locations = this.state && this.state.Locations[i];
    if (locations && locations.is_default_address === true) {
      toast.error(this.props.t('Toast.Error.DeleteDefaultLocation'));
      return;
    }
    this.setState({
      Locations: this.state.Locations.filter((s, sidx) => i !== sidx),
    });
  };

  removeAlternetAgentRow = (i) => {
    this.setState({
      alternetAgents: this.state.alternetAgents.filter((s, sidx) => i !== sidx),
    });
  };

  alternateAgentsMethod = () => {
    const readOnly =
      this.state.operation === 'View' || this.state.operation === 'Edit';
    if (!readOnly) {
      this.addAlterAgentRow();
      this.createRowAlterAgent();
    }
  };

  handleValidatePatientId = () => {
    const { patient_id, parent_account_id } = this.state;
    let obj = {
      patientId: patient_id.toString(),
      accountId: parent_account_id,
    };
    fetch(process.env.REACT_APP_BASEURL + 'patient-exist', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((patientResponse) => {
        if (patientResponse.isPatientExist) {
          this.setState({
            isPatientExist: patientResponse.isPatientExist,
            loader: false,
          });
          toast.error(this.props.t('Toast.Error.PatientRecordExist'));
        }
      });
  };

  handleParentChange = (event) => {
    this.setState({ parent_account_id: event.target.value });
    const getAccountByID = this.state.accountValues.find(
      (x) => x.value === event.target.value
    );
    if (getAccountByID)
      this.setState({ preferLanguage: getAccountByID['preferredLanguage'] });
  };

  handlRequestConsent = () => {
    const { customer_pkid, parent_account_id, box_id, Locations } = this.state;
    if (Locations && Locations.length && Locations.length > 0) {
      this.setState({ innerConsentloader: true, isResuestConsent: true });
      let obj = {
        patientId: customer_pkid,
        accountId: parent_account_id,
        boxId: box_id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'patient/sms-enrollment', {
        method: 'POST',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-type': 'application/json',
        },
        body: JSON.stringify(obj),
      })
        .then((res) => res.json())
        .then((res) => {
          if (
            res &&
            res.isEmailSent &&
            res.isEmailSent === true &&
            res.isSMSsent &&
            res.isSMSsent === true
          ) {
            toast.success(
              this.props.t('Toast.Patient.Request')
            );
            this.setState({
              innerConsentloader: false,
              isResuestConsent: false,
            });
          }
          // else{
          //   toast.warn('Please select default location and update patient');
          this.setState({ innerConsentloader: false, isResuestConsent: false });
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      toast.error(this.props.t('Toast.Error.AddLocationUpdatePatient'));
      this.setState({ innerConsentloader: false, isResuestConsent: false });
    }
  };

  handleExpansionPanelChange = (panel) => (expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  onChangePreferredLanguage = (event) => {
    event.preventDefault && event.preventDefault();
    const { value } = event.target;
    this.setState({ preferLanguage: value });
  };

  SyncMadicationHistory = (event) => {
    this.setState({ loader: true });
    this.setState({ anchorEl: event.currentTarget });
  };

  onChangePinNumber = (event) => {
    const { value } = event.target;
    this.setState({ pin: value });
  };

  changePatientType = (event) => {
    event.preventDefault();
    const { value } = event.target;
    this.setState({ isPet: value });
  };

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource()
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = () => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }
        apiCall()

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + 'getCustomers', {
            method: 'POST',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj)
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                self.setState({ loader: false });
                return null;
              }
            })
            .then((data) => {
              self.setState({ totalRecords: data && data.total });
              if (data && data.results) {
                if (data.results.length > 0) {
                  data.results.map((n) => {
                    n.email =
                      n.contacts && n.contacts.length > 0 ? n.contacts[0].email : '';
                    n.phone =
                      n.contacts && n.contacts.length > 0 ? n.contacts[0].phone : '';
                    n.is_active =
                      n.legaldocs && n.legaldocs.is_active === true
                        ? self.props.t('Patient.Active')
                        : self.props.t('Patient.InActive');
                    return n;
                  });
                  params.successCallback(data.results, data.total);
                  self.setState({ data: data.results, loader: false, isDataEmpty: false, selected: [] })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], loader: false, isDataEmpty: true, selected: [] })
                }
                self.setState({ loader: false, selected: [] })
              }
            })
            .catch(error => {
              self.setState({ loader: false, selected: [] })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  onRowSelected = (params) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(params.data.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, params.data.id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    this.setState({ selected: newSelected });
  };

  retrieveData = (selectedObject) => {
    this.setState({ ...selectedObject }, () => {
      const promises = this.state.Locations.map((item) => {
        return fetch(`${process.env.REACT_APP_BASEURL}boxes/${item.box_id}`, {
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          return response.json();
        });
      });
      Promise.all(promises).then((results) => {
        let lo = this.state.Locations;
        for (let i = 0; i < results.length; i++) {
          lo[i].courier_type = [];
          let t = results[i];
          for (let j = 0; j < t.length; j++) {
            lo[i].courier_type = t[j].courier_type;
          }
        }
        this.setState({ Locations: lo });
      });
    })
  }

  ActionCellRenderer = (t, classes) => {
    return (params) => {
      return (
        <VerticalMenu
          t={t}
          classes={classes}
          params={params}
          state={this.state}
          retrieveData={this.retrieveData}
          account={account}
        />
      )
    }
  }

  render() {
    const { classes, theme, t } = this.props;
    const {
      selected,
      shouldLookUpEnabled,
      // totalRecords,
      locale,
    } = this.state;
    const readOnly = this.state.operation === 'View';

    const columnDefs = [
      {
        field: "picture_url", headerName: t("Patient.Picture"), sortable: false, filter: false, cellRenderer: (params) => (<Avatar alt="" src={params.data.picture_url} />),
      },
      { field: "name", headerName: t("Patient.Name") },
      { field: "username", headerName: t("Patient.UserName") },
      { field: "email", headerName: t("Patient.Email"), cellRenderer: (params) => params.data.contacts[0].email ? params.data.contacts[0].email : '' },
      { field: "phone", headerName: t("Patient.Phone"), cellRenderer: (params) => params.data.contacts[0].phone ? params.data.contacts[0].phone : '' },
      {
        field: "dob_str", headerName: t("Patient.DOB"),
        cellRenderer: (params) => params.data.dob_str ? params.data.dob_str : '',
        filterParams: {
          filterPlaceholder: 'MM/DD/YYYY'
        }
      },
      {
        field: "is_consent_accepted", headerName: t("Patient.Status"), sortable: false, filter: false,
        cellRenderer: (params) => params.data.is_consent_accepted === true || params.data.is_consent_accepted === 'true' ? t('Patient.Active') : t('Patient.InActive')
      },
      {
        field: "type", headerName: t("Patient.Type"), sortable: false, filter: false, cellRenderer: (params) => this.filterCustomerType(params.data && params.data.customerType && params.data.customerType.name)
      },
      {
        field: "is_enabled", headerName: t("Patient.Enabled"), sortable: false, filter: false,
        cellRenderer: (params) => params.data.is_enabled === true || params.data.is_enabled === 'true' ? t('Global.Consultation.Action.Yes') : t('Global.Consultation.Action.No')
      },
      {
        field: "actions", headerName: t("Patient.Actions"), minWidth: 120, filter: false, sortable: false,
        cellRenderer: this.ActionCellRenderer(t, classes)
      },
    ];

    return (
      <div>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <Dialog
          open={this.state.deleteDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Patient.AreYouSureToDelete')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Patient.AreYouSureToDeletePatient')} :
              <ul>
                {this.state.forDeletion &&
                  this.state.forDeletion.map(function (a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Patient.CancelButton')}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Patient.DeleteActions')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.confirmresetpw || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Patient.AreYouSureWantToResetPass')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Patient.AreYouSureWantToResetPass')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.confirmresetpwClose} color='primary'>
              {t('Patient.NO')}
            </Button>
            <Button onClick={this.confirmresetpw} color='primary' autoFocus>
              {t('Patient.YES')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.OpenConfirmCode || false}
          aria-labelledby='form-dialog-title'
        >
          <ValidatorForm
            ref='form'
            onSubmit={
              this.state.operation === 'Add'
                ? this.handleSubmit
                : this.handleUpdate
            }
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Patient.Verification')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                <TextValidator
                  autoFocus={true}
                  className={classes.halfTextField}
                  margin='normal'
                  id='ConfirmCode'
                  name='confirmcode'
                  value={this.state.confirmcode}
                  label={t('Patient.EnterValidationCode')}
                  type='confirm code'
                  onChange={this.handleChangeConfirmcode}
                  inputProps={{ readOnly: Boolean(readOnly), maxLength: 50 }}
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.confirmcodeClose} color='primary'>
                {t('Patient.CancelButton')}
              </Button>
              <Button onClick={this.confirmcode} color='primary' autoFocus>
                {t('Patient.Verify')}
              </Button>
            </DialogActions>
          </ValidatorForm>
        </Dialog>
        <Dialog
          maxWidth={'md'}
          fullWidth={true}
          open={this.state.showNewUserDialog || false}
          onClose={this.handleClose}
          aria-labelledby='form-dialog-title'
          PaperProps={{
            sx: { minWidth: '1150px' },
          }}
        >
          <AppBar position='static' color='default'>
            <Tabs
              value={this.state.selectedTab}
              onChange={this.handleTabChange}
              indicatorColor='primary'
              textColor='primary'
              variant={null}
            >
              <Tab
                label={t('Patient.Details.DetailsTitle')}
                sx={{ width: '15%' }}
              />
              <Tab
                label={t('Patient.Preference.PreferenceTitle')}
                sx={{ width: '15%' }}
              />
              <Tab
                label={t('Patient.Consent.ConsentTitle')}
                sx={{ width: '15%' }}
              />
              {this.state && this.state.operation === 'Add' ? (
                ''
              ) : (
                <Tab
                  label={t('Patient.History.HistoryTitle')}
                  sx={{ width: '15%' }}
                />
              )}
              {this.state && this.state.operation === 'Add' ? (
                ''
              ) : (
                <Tab
                  label={t('Patient.Payment.PaymentTitle')}
                  sx={{ width: '15%' }}
                />
              )}
              {this.state && this.state.operation === 'Add' ? (
                ''
              ) : (
                <Tab
                  label={t('Patient.Medication.MedicationTitle')}
                  sx={{ width: '15%' }}
                />
              )}
            </Tabs>
          </AppBar>

          <ValidatorForm ref='form' onSubmit={this.handleValidate}>
            <SwipeableViews
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={this.state.selectedTab}
              onChangeIndex={() => this.handleChangeIndex}
            >
              <TabContainer dir={theme.direction}>
                <Box>
                  <DialogTitle id='form-dialog-title'>
                    {t(this.state.operation)} {t('Patient.Details.Patient')}
                  </DialogTitle>
                  <DialogContent>
                    {this.state.innerloader ? (
                      <div className={classes.spinner}>
                        <img
                          className={classes.spinnerImage}
                          src={spinner}
                          alt='loading'
                        />
                      </div>
                    ) : null}
                    <DialogContentText>
                      {t('Patient.Details.DetailsNotes')}
                      <br />
                      <span className={classes.errorDiv}>
                        {this.state.errorMessage}
                      </span>
                    </DialogContentText>
                    <Selector
                      id='parent_account_id'
                      label={t('Patient.Details.ParentAccount')}
                      values={this.state.accountValues}
                      selected={this.state.parent_account_id}
                      onBlur={(e) => this.handleParentChange(e)}
                      readOnly={readOnly}
                    />
                    {this.state.operation === 'Add' &&
                      shouldLookUpEnabled === true ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          marginTop: '15px',
                        }}
                      >
                        <FormControl component='fieldset'>
                          <FormLabel component='legend'>
                            {t('Patient.Details.LookupPatientBy')}
                          </FormLabel>
                          <RadioGroup
                            style={{ flexDirection: 'row' }}
                            aria-label='patientSelectedAction'
                            name='patientSelectedAction'
                            value={this.state.patientSelectedAction}
                            onChange={this.handleRadioChange}
                          >
                            <FormControlLabel
                              value='MRN'
                              control={<Radio />}
                              label={t('Patient.Details.MRNCheckBox')}
                            />
                            <FormControlLabel
                              value='MYCHARTLOGIN'
                              control={<Radio />}
                              label={t(
                                'Patient.Details.MyChartUserNameCheckBox'
                              )}
                            />
                          </RadioGroup>
                        </FormControl>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'flex-end',
                          }}
                        >
                          <TextValidator
                            autoFocus
                            className={classes.searchHalfTextField}
                            margin='normal'
                            id='searchPatient'
                            name='searchPatient'
                            value={this.state.searchPatient}
                            label={`${t('Patient.Details.SearchByMRN')} ${this.state.searchPatientAction
                              }`}
                            type='searchPatient'
                            placeholder=''
                            onChange={this.handleLookupPatientSearch}
                            variant='standard'
                          />
                          <Button
                            onClick={this.handleLookupPatient}
                            color='primary'
                            sx={{ ml: '2rem' }}
                          >
                            {t('Patient.Details.LookupButton')}
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    <div className={classes.twoChildren}>
                      <div className={classes.leftChild}>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            autoFocus
                            className={classes.halfTextField}
                            margin='normal'
                            id='first_name'
                            name='first_name'
                            value={
                              this.state.user.first_name ||
                              this.state.first_name
                            }
                            label={t('Patient.Details.FirstName')}
                            type='first-name'
                            placeholder=''
                            onChange={this.handleChange}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                            }}
                            validators={['required']}
                            errorMessages={[
                              t('Validation.EnterFirstName'),
                            ]}
                            variant='standard'
                          />
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='last_name'
                            name='last_name'
                            value={
                              this.state.user.last_name || this.state.last_name
                            }
                            label={t('Patient.Details.LastName')}
                            type='last-name'
                            onChange={this.handleChange}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                            }}
                            validators={['required']}
                            errorMessages={[
                              t('Validation.EnterLastName'),
                            ]}
                            variant='standard'
                          />
                        </div>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='email'
                            name='email'
                            inputProps={{ readOnly: Boolean(readOnly) }}
                            value={this.state.user.email || this.state.email}
                            label={t('Patient.Details.EmailAddress')}
                            type='email'
                            onChange={this.handleChange}
                            validators={['required', 'isEmail']}
                            errorMessages={[
                              t('Validation.EnterEmailAddress'),
                              t('Validation.EmailIsNotValid'),
                            ]}
                            variant='standard'
                          />
                          <PhoneInput
                            labelStyle={{ left: '-13px', top: '-17px' }}
                            style={{ width: '400px', marginTop: '15px' }}
                            id='phone'
                            name='phone'
                            onBlur={this.handleChange}
                            defaultValue={
                              this.state.user.phone || this.state.phone
                            }
                            readOnly={readOnly}
                          />
                        </div>
                        <div style={{ display: 'flex' }}>
                          <LocalizationProvider
                            dateAdapter={DateAdapter}
                            locale={locale}
                          >
                            <DesktopDatePicker
                              keyboard
                              clearable
                              format='MM/dd/yyyy'
                              value={this.state.dob}
                              disableFuture
                              onChange={this.handleDateChange}
                              disabled={readOnly}
                              style={{ width: '330px' }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={t('Patient.Details.DateOfBirth')}
                                  variant='standard'
                                  sx={{
                                    '&.MuiFormControl-root': {
                                      width: '400px',
                                      mt: '25px',
                                    },
                                  }}
                                />
                              )}
                            />
                          </LocalizationProvider>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='Patient_Record_Number'
                            name='Patient_Record_Number'
                            value={this.state.patient_id}
                            label={t('Patient.Details.PatientRecordNumber')}
                            type='Patient-Record-Number'
                            placeholder=''
                            onChange={this.handlePatientIdChange}
                            onBlur={this.handleValidatePatientId}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                            }}
                            validators={['required']}
                            errorMessages={[
                              t('Patient.Validation.EnterPatientRecordNumber'),
                            ]}
                            style={{ marginLeft: '20px', marginTop: '25px' }}
                            variant='standard'
                          />
                        </div>
                      </div>
                      <div
                        className={classes.rightChild}
                        style={{ marginLeft: '60px', marginTop: '23px' }}
                      >
                        <div className={classes.dropbox}>
                          {readOnly ? (
                            <div>
                              {!this.state.avatarPreview && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.avatarPreview && (
                                <img
                                  alt=''
                                  src={this.state.avatarPreview}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              id='avatardropzone'
                              onDrop={this.handleDrop.bind(this)}
                              className={classes.innerBox}
                            >
                              {!this.state.avatarPreview && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.avatarPreview && (
                                <img
                                  alt=''
                                  src={this.state.avatarPreview}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <br />
                        <div variant='caption'>
                          <p className={classes.captionText}>
                            {t('Patient.Details.UploadImage')}
                          </p>
                          <Button onClick={this.removeImg}>
                            {t('Patient.Details.RemoveImageButton')}
                          </Button>
                        </div>
                      </div>
                    </div>
                    <Grid>
                      <TextValidator
                        className={classes.halfTextField}
                        margin='normal'
                        id='Loyalty_Number'
                        name='Loyalty_Number'
                        value={this.state.member_id}
                        label={t('Patient.Details.MemberNumberOrLoyaltyNumber')}
                        type='Loyalty_Number'
                        placeholder=''
                        onChange={this.handleMemberNumber}
                        inputProps={{
                          readOnly: Boolean(readOnly),
                          maxLength: 50,
                        }}
                        variant='standard'
                      />
                    </Grid>
                    <br />
                    <Typography
                      variant='title'
                      style={{
                        paddingTop: '5px',
                        marginRight: '6px',
                        color: 'black',
                        fontzWeight: 500,
                        fontSize: '1.3125rem',
                        lineHeight: '1.16667em',
                      }}
                    >
                      {t('Patient.Details.PatientDeliveryAddress')}
                    </Typography>
                    <Table className={classes.SeparateRow}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            colSpan={3}
                            className={classes.tableAddRowCell}
                          >
                            <div className={classes.addRowIcon}>
                              <Button
                                onClick={this.addPatientDeliveryAddressRow}
                                color='primary'
                                disabled={Boolean(readOnly)}
                                sx={{ marginLeft: '-5px' }}
                              >
                                {t('Patient.Details.AddPatientAddressButton')}
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.createPatientDeliveryAddressRow()}
                      </TableBody>
                    </Table>
                  </DialogContent>
                  <div
                    style={{ position: 'absolute', bottom: '0', width: '100%' }}
                  >
                    <DialogActions sx={{ padding: '8px 37px 8px 8px' }}>
                      <Button
                        onClick={this.handleClose}
                        color='primary'
                        className={classes.primaryButton}
                      >
                        {this.state.operation === 'View'
                          ? t('Patient.CloseButton')
                          : t('Patient.CancelButton')}
                      </Button>
                      {this.state.operation !== 'View' && (
                        <Button
                          type='submit'
                          disabled={this.state.isButtonDisabled}
                          color='primary'
                          className={classes.primaryButton}
                        >
                          {this.state.operation === 'Edit'
                            ? t('Patient.UpdatePatientButton')
                            : t('Patient.AddPatientButton')}
                        </Button>
                      )}
                    </DialogActions>
                  </div>
                </Box>
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <DialogContent>
                  <DialogContentText>
                    {t('Patient.Preference.WhereLikeNotes')}
                    <br />
                    <span className={classes.errorDiv}>
                      {this.state.errorMessage}
                    </span>
                  </DialogContentText>

                  <Typography variant='title'>
                    {t('Patient.Preference.LocationTitle')}
                  </Typography>
                  <Table className={classes.SeparateRow}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          className={classes.tableAddRowCell}
                        >
                          <div className={classes.addRowIcon}>
                            <Button
                              onClick={this.addRow}
                              color='primary'
                              style={{ marginLeft: '-5px' }}
                            >
                              {t('Patient.Preference.AddLocationButton')}
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{this.createRow()}</TableBody>
                  </Table>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.ada}
                          onChange={this.handleChangeAda}
                          value='ADA'
                          color='primary'
                        />
                      }
                      label={
                        <span
                          style={{
                            color: '#000',
                            fontSize: '0.875rem',
                            fontWeight: '400',
                            lineHeight: '1.46429em',
                          }}
                        >
                          {t('Patient.Preference.ADACompatibleCheckbox')}
                        </span>
                      }
                    />
                  </div>

                  <div style={{ marginTop: '2%' }}>
                    <div>
                      <Grid container spacing={3}>
                        <Grid item xs={2} style={{ paddingLeft: '0px' }}>
                          <span
                            style={{
                              color: 'black',
                              fontSize: 'large',
                              fontWeight: '500',
                            }}
                          >
                            {t('Patient.Preference.NotificationTitle')}
                          </span>
                          <div>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.Nemail}
                                  onChange={this.handleChangeEmail}
                                  value='Email'
                                  color='primary'
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: '#000',
                                    fontSize: '0.875rem',
                                    fontWeight: '400',
                                    lineHeight: '1.46429em',
                                    marginLeft: '20px',
                                  }}
                                >
                                  {t('Patient.Preference.EmailCheckbox')}
                                </span>
                              }
                            />
                          </div>
                          <div>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  disabled={false}
                                  checked={this.state.Nsms}
                                  onChange={this.handleChangeSms}
                                  value={t('Global.SMS')}
                                  color='primary'
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: '#000',
                                    fontSize: '0.875rem',
                                    fontWeight: '400',
                                    lineHeight: '1.46429em',
                                    marginLeft: '20px',
                                  }}
                                >
                                  {t('Patient.Preference.SMSCheckbox')}
                                </span>
                              }
                            />
                          </div>

                          <div>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  disabled={true}
                                  checked={this.state.Npush}
                                  onChange={this.handleChangePush}
                                  value='PUSH'
                                  color='primary'
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: '#000',
                                    fontSize: '0.875rem',
                                    fontWeight: '400',
                                    lineHeight: '1.46429em',
                                    marginLeft: '20px',
                                  }}
                                >
                                  {t('Patient.Preference.PushCheckBox')}
                                </span>
                              }
                            />
                          </div>
                        </Grid>
                        <Grid item xs={3}>
                          <div>
                            <FormControl>
                              <InputLabel
                                htmlFor='age-simple'
                                sx={{ ml: '-7%' }}
                              >
                                {t('Patient.Preference.PreferredLanguage')}
                              </InputLabel>
                              <Select
                                style={{ width: '200px' }}
                                value={this.state.preferLanguage || ''}
                                readOnly={readOnly}
                                onChange={this.onChangePreferredLanguage}
                                inputProps={{
                                  name: 'preferrdlanguage',
                                  id: 'preferrdlanguage',
                                }}
                                variant='standard'
                              >
                                {this.state &&
                                  this.state.preferredLanguage.map(
                                    (item, index) => (
                                      <MenuItem
                                        key={index}
                                        value={item && item.id}
                                        selected
                                      >
                                        {item && item.label}
                                      </MenuItem>
                                    )
                                  )}
                              </Select>
                            </FormControl>
                          </div>
                          <div style={{ marginTop: '12%' }}>
                            <FormControl>
                              <InputLabel
                                htmlFor='age-simple'
                                sx={{ ml: '-7%' }}
                              >
                                {t('Patient.Preference.PatientType')}
                              </InputLabel>
                              <Select
                                style={{ width: '200px' }}
                                value={this.state.isPet}
                                readOnly={readOnly}
                                inputProps={{
                                  name: 'is_pet',
                                  id: 'is_pet',
                                }}
                                variant='standard'
                                onChange={this.changePatientType}
                              >
                                <MenuItem
                                  value='false'
                                  selected
                                  className={classes.menuItem}
                                >
                                  {t('Global.Type.Human')}
                                </MenuItem>
                                <MenuItem
                                  value='true'
                                  className={classes.menuItem}
                                >
                                  {t('Global.Type.Animal')}
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>
                        <Grid item xs={3}>
                          <div>
                            <TextField
                              style={{ marginTop: '0', width: '100%' }}
                              margin='dense'
                              value={this.state.pin}
                              id='pin number'
                              label={t('Patient.Preference.PinNumber')}
                              placeholder=''
                              onChange={this.onChangePinNumber}
                              fullWidth
                              inputProps={{
                                readOnly: Boolean(readOnly),
                                maxLength: 4,
                                autocomplete: 'new-password',
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                              variant='standard'
                            />
                          </div>
                        </Grid>
                      </Grid>
                      <Grid>
                        <div style={{ marginTop: '2%' }}>
                          <FormControlLabel
                            control={
                              <Switch
                                name='checkedPayroll'
                                color='primary'
                                checked={this.state.IsPayrollDeduct}
                                onChange={this.handleSwitchChangePayroll(
                                  'checked'
                                )}
                                value='checked'
                              />
                            }
                            label={
                              <span
                                style={{
                                  color: '#000',
                                  fontSize: '0.875rem',
                                  fontWeight: '400',
                                  lineHeight: '1.46429em',
                                }}
                              >
                                {t('Patient.Preference.PayrollDeductionToggle')}
                              </span>
                            }
                          />

                          <Grid item xs={12}>
                            <Button
                              style={{ marginLeft: '-1%', marginTop: '1%' }}
                              onClick={this.addAlterAgentRow}
                              color='primary'
                            >
                              {t(
                                'Patient.Preference.AddAlternateContactButton'
                              )}
                            </Button>
                            {this.createRowAlterAgent()}
                          </Grid>
                        </div>
                      </Grid>
                      <Grid container>
                        <Grid item xs={2}>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='patient_notes'
                            name='patient_notes'
                            value={
                              this.state.user.patient_notes ||
                              this.state.patient_notes
                            }
                            label={t('Patient.Preference.PatientNotes')}
                            type='text'
                            placeholder=''
                            onChange={this.onChangeLocationnotes}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                            }}
                            variant='standard'
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </DialogContent>
                <div
                  style={{ position: 'absolute', bottom: '0', width: '100%' }}
                >
                  <DialogActions sx={{ padding: '8px 37px 8px 8px' }}>
                    <Button
                      onClick={this.handleClose}
                      color='primary'
                      className={classes.primaryButton}
                    >
                      {this.state.operation === 'View'
                        ? t('Patient.CloseButton')
                        : t('Patient.CancelButton')}
                    </Button>
                    {this.state.operation !== 'View' && (
                      <Button
                        type='submit'
                        disabled={this.state.isButtonDisabled}
                        color='primary'
                        className={classes.primaryButton}
                      >
                        {this.state.operation === 'Edit'
                          ? t('Patient.UpdatePatientButton')
                          : t('Patient.AddPatientButton')}
                      </Button>
                    )}
                  </DialogActions>
                </div>
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <div className={classes.paddedBoxDivEdit}>
                  <DialogTitle id='form-dialog-title'>
                    {t('Patient.Consent.ConsentForm')}
                  </DialogTitle>
                  <DialogContent>
                    <div className={classes.flexItems + ' box-container'}>
                      <Grid container xs={12}>
                        <Grid item xs={4}>
                          <div className='box'>
                            <div className={classes.advdropbox}>
                              {readOnly ? (
                                <div className={classes.innerBox}>
                                  {(!this.state.LCPreview ||
                                    this.state.LCPreview === null ||
                                    this.state.LCPreview === 'null' ||
                                    this.state.LCPreview === undefined ||
                                    this.state.LCPreview === 'undefined') && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                  {this.state.LCPreview && (
                                    <img
                                      alt=''
                                      src={FileIcon}
                                      style={{
                                        width: '50%',
                                        height: 'auto',
                                        marginTop: '10%',
                                      }}
                                      className={classes.dropPic}
                                    />
                                  )}
                                </div>
                              ) : (
                                <Dropzone
                                  id='LegalConsentdropzone'
                                  onDrop={this.handleLCDrop.bind(this)}
                                  className={classes.innerBox}
                                >
                                  {(!this.state.LCPreview ||
                                    this.state.LCPreview === null ||
                                    this.state.LCPreview === 'null' ||
                                    this.state.LCPreview === undefined ||
                                    this.state.LCPreview === 'undefined') && (
                                      <AddUserImage
                                        className={classes.dropImage}
                                      />
                                    )}
                                  {this.state.LCPreview && (
                                    <img
                                      alt=''
                                      src={FileIcon}
                                      style={{
                                        width: '50%',
                                        height: 'auto',
                                        marginTop: '10%',
                                      }}
                                      className={classes.dropPic}
                                    />
                                  )}
                                </Dropzone>
                              )}
                            </div>
                            <div
                              variant='caption'
                              style={{ marginTop: '25px', textAlign: 'center' }}
                            >
                              {this.state.LCfilename !== '' ? (
                                <p>{this.state.LCfilename}</p>
                              ) : (
                                ''
                              )}
                              {(this.state.LCPreview === null ||
                                this.state.LCPreview === 'null' ||
                                this.state.LCPreview === undefined ||
                                this.state.LCPreview === 'undefined') &&
                                (this.state.customerLCpreview === null ||
                                  this.state.customerLCpreview === 'null' ||
                                  this.state.customerLCpreview === undefined ||
                                  this.state.customerLCpreview ===
                                  'undefined') ? (
                                <p className={classes.captionadvText}>
                                  {t('Patient.Consent.UploadDocument')}
                                </p>
                              ) : (
                                <Button
                                  className={classes.btnremove}
                                  onClick={this.PreviewLC}
                                >
                                  {t('Patient.Consent.Preview')}
                                </Button>
                              )}
                              {(this.state.LCPreview === null ||
                                this.state.LCPreview === 'null' ||
                                this.state.LCPreview === undefined ||
                                this.state.LCPreview === 'undefined') &&
                                (this.state.customerLCpreview === null ||
                                  this.state.customerLCpreview === 'null' ||
                                  this.state.customerLCpreview === undefined ||
                                  this.state.customerLCpreview ===
                                  'undefined') ? (
                                ''
                              ) : (
                                <Button
                                  className={classes.btnremove}
                                  onClick={this.removeLC}
                                >
                                  {t('Patient.Consent.RemoveDocument')}
                                </Button>
                              )}
                              {this.state.innerConsentloader ? (
                                <div className={classes.spinnerConsent}>
                                  <img
                                    className={classes.spinnerImageConsent}
                                    src={spinner}
                                    alt='loading'
                                  />
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={2}>
                          <FormControlLabel
                            control={
                              <Switch
                                name='consent'
                                color='primary'
                                checked={this.state.IsConsent}
                                onChange={this.handleSwitchChangeConsent(
                                  'checkedB'
                                )}
                                value='checkedB'
                                disabled={this.state.operation === 'View'}
                              />
                            }
                            label={
                              <span
                                style={{
                                  fontSize: '0.875rem',
                                  fontWeight: 400,
                                }}
                              >
                                {t('Patient.Consent.ConsentToggle')}
                              </span>
                            }
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Button
                            disabled={
                              this.state.operation === 'Add' ||
                              this.state.operation === 'View' ||
                              (this.state && this.state.isResuestConsent)
                            }
                            color='primary'
                            style={{ marginLeft: 20 }}
                            onClick={this.handlRequestConsent}
                          >
                            {t('Patient.Consent.PleaseJoinNewEmailButton')}
                          </Button>
                        </Grid>
                        <Grid item xs={3}>
                          <label
                            style={{
                              fontSize: ' 0.875rem',
                              fontWeight: 400,
                              lineHeight: '1.46429em',
                            }}
                          >
                            {t('Patient.Consent.ConsentJoinNotes')}
                          </label>
                        </Grid>
                      </Grid>
                    </div>

                    <Grid container item xs={12} style={{ marginTop: '3%' }}>
                      <Grid ietm xs={4}>
                        {this.state.signature ||
                          this.state.patient_signature ? (
                          <div>
                            <img
                              style={{ width: '300px', marginTop: '5px' }}
                              src={
                                this.state.signature ||
                                this.state.patient_signature
                              }
                              alt='signature'
                            />
                          </div>
                        ) : (
                          ''
                        )}
                      </Grid>
                      <Grid ietm xs={2}>
                        {this.state && this.state.patient_signature_time ? (
                          <label style={{ fontSize: '1.0rem' }}>
                            Received On
                            <p style={{ fontSize: '1.1rem' }}>
                              {moment(
                                this.state && this.state.patient_signature_time
                              ).format('MM/DD/YYYY')}{' '}
                            </p>
                          </label>
                        ) : (
                          ''
                        )}
                      </Grid>
                      <Grid item xs={6} style={{ marginTop: '-18%' }}>
                        <div
                          style={{
                            background:
                              'linear-gradient(135deg, white, #dedede)',
                          }}
                        >
                          {(this.state.docOneLabel === '' ||
                            this.state.docOneLabel === null ||
                            this.state.docOneLabel === 'null' ||
                            this.state.docOneLabel === undefined ||
                            this.state.docOneLabel === 'undefined') &&
                            (this.state.docOneDataURL === '' ||
                              this.state.docOneDataURL === null ||
                              this.state.docOneDataURL === 'null' ||
                              this.state.docOneDataURL === undefined ||
                              this.state.docOneDataURL === 'undefined') ? (
                            ''
                          ) : (
                            <Accordion
                              square
                              expanded={this.state.expanded === 'panel1'}
                              onChange={this.handleExpansionPanelChange(
                                'panel1'
                              )}
                            >
                              <AccordionSummary>
                                <Typography
                                  style={{
                                    fontSize: '1.2em',
                                    fontWeight: '500',
                                    color: '#4b8883',
                                  }}
                                >
                                  {this.state.docOneLabel}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails
                                className={classNames(classes.expansingDetails)}
                                style={{ height: '395px', overflowY: 'auto' }}
                              >
                                <div
                                  style={{
                                    color: '#387371',
                                    textAlign: 'justify',
                                  }}
                                >
                                  <iframe
                                    src={this.state.docOneDataURL}
                                    height='360px'
                                    width='170%'
                                    title='Preview'
                                    scrolling='yes'
                                  />
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          )}

                          {(this.state.docTwoLabel === '' ||
                            this.state.docTwoLabel === null ||
                            this.state.docTwoLabel === 'null' ||
                            this.state.docTwoLabel === undefined ||
                            this.state.docTwoLabel === 'undefined') &&
                            (this.state.docTwoDataURL === '' ||
                              this.state.docTwoDataURL === null ||
                              this.state.docTwoDataURL === 'null' ||
                              this.state.docTwoDataURL === undefined ||
                              this.state.docTwoDataURL === 'undefined') ? (
                            ''
                          ) : (
                            <Accordion
                              square
                              expanded={this.state.expanded === 'panel2'}
                              onChange={this.handleExpansionPanelChange(
                                'panel2'
                              )}
                            >
                              <AccordionSummary>
                                <Typography
                                  style={{
                                    fontSize: '1.2em',
                                    fontWeight: '500',
                                    color: '#4b8883',
                                  }}
                                >
                                  {this.state.docTwoLabel}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails
                                className={classNames(classes.expansingDetails)}
                                style={{ height: '400px', overflowY: 'auto' }}
                              >
                                <div
                                  style={{
                                    color: '#387371',
                                    textAlign: 'justify',
                                  }}
                                >
                                  <iframe
                                    src={this.state.docTwoDataURL}
                                    height='360px'
                                    width='170%'
                                    title='Preview'
                                    scrolling='yes'
                                  />
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          )}

                          {(this.state.docThreeLabel === '' ||
                            this.state.docThreeLabel === null ||
                            this.state.docThreeLabel === 'null' ||
                            this.state.docThreeLabel === undefined ||
                            this.state.docThreeLabel === 'undefined') &&
                            (this.state.docThreeDataURL === '' ||
                              this.state.docThreeDataURL === null ||
                              this.state.docThreeDataURL === 'null' ||
                              this.state.docThreeDataURL === undefined ||
                              this.state.docThreeDataURL === 'undefined') ? (
                            ''
                          ) : (
                            <Accordion
                              square
                              expanded={this.state.expanded === 'panel3'}
                              onChange={this.handleExpansionPanelChange(
                                'panel3'
                              )}
                            >
                              <AccordionSummary>
                                <Typography
                                  style={{
                                    fontSize: '1.2em',
                                    fontWeight: '500',
                                    color: '#4b8883',
                                  }}
                                >
                                  {this.state.docThreeLabel}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails
                                className={classNames(classes.expansingDetails)}
                                style={{ height: '400px', overflowY: 'auto' }}
                              >
                                <div
                                  style={{
                                    color: '#387371',
                                    textAlign: 'justify',
                                  }}
                                >
                                  <iframe
                                    src={this.state.docThreeDataURL}
                                    height='360px'
                                    width='170%'
                                    title='Preview'
                                    scrolling='yes'
                                  />
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          )}
                        </div>
                      </Grid>
                    </Grid>

                    <Dialog
                      open={this.state.openIframe}
                      fullWidth={true}
                      maxWidth={'md'}
                    >
                      <Paper className={classes.previewBox}>
                        <DialogContent>
                          {this.state.openIframe ? (
                            <div>
                              <iframe
                                src={this.state.dataUrl}
                                className={classes.mainIframe}
                                title='Preview'
                              />
                            </div>
                          ) : (
                            ''
                          )}
                        </DialogContent>
                        <DialogActions className={classes.previewFooter}>
                          <div>
                            <Button
                              onClick={this.handleClosePreview}
                              color='primary'
                            >
                              {t('Patient.CloseButton')}
                            </Button>
                          </div>
                        </DialogActions>
                      </Paper>
                    </Dialog>
                  </DialogContent>
                  <div
                    style={{ position: 'absolute', bottom: '0', width: '100%' }}
                  >
                    <DialogActions sx={{ padding: '8px 37px 8px 8px' }}>
                      <Button
                        onClick={this.handleClose}
                        color='primary'
                        className={classes.primaryButton}
                      >
                        {this.state.operation === 'View'
                          ? t('Patient.CloseButton')
                          : t('Patient.CancelButton')}
                      </Button>
                      {this.state.operation !== 'View' && (
                        <Button
                          type='submit'
                          disabled={this.state.isButtonDisabled}
                          color='primary'
                          className={classes.primaryButton}
                        >
                          {this.state.operation === 'Edit'
                            ? t('Patient.UpdatePatientButton')
                            : t('Patient.AddPatientButton')}
                        </Button>
                      )}
                    </DialogActions>
                  </div>
                </div>
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <PatientHistoryTab
                  patient={this.state && this.state.user}
                  operation={this.state.operation}
                  close={this.handleClose}
                />
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <PaymentMethods
                  patient={this.state && this.state.user}
                  operation={this.state.operation}
                  close={this.handleClose}
                />
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <PatientMadicationHistoryTab
                  patient={this.state && this.state.user}
                />
              </TabContainer>
            </SwipeableViews>
          </ValidatorForm>
        </Dialog>
        <EnhancedTableToolbar
          numSelected={selected.length}
          add={this.addUser}
          deleteUsers={this.deleteUsers}
          confirmDelete={this.confirmDelete}
          padd={this.state.patientadd}
          pdelete={this.state.patientdelete}
          clearFilters={this.clearFilters}
        />
        <ReportsAGGrid
          columnDefs={columnDefs}
          sideBar={false}
          suppressMenuHide={true}
          defaultColDef={{
            flex: 1,
            minWidth: 150,
            floatingFilter: true,
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: [{
                displayKey: 'searchtext',
                displayName: 'Search Text',
                predicate: (cellValue) => cellValue
              }],
              maxNumConditions: 1,
            },
            resizable: true,
            sortable: true,
            menuTabs: ['generalMenuTab', 'columnsMenuTab'],

          }}
          rowHeight={45}
          onGridReady={this.onGridReady}
          getRowId={(params) => params.data.id}
          onRowSelected={this.onRowSelected}
        />
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withTranslation()(EnhancedTable)
);



// WEBPACK FOOTER //
// ./src/components/patient-list/index.js